import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../config';
import GuestHistoryBadge from './GuestHistoryBadge';
import { requireUserId } from './userSession';
import { isGstApplicable } from './gstSettings';
import { Backdrop, CircularProgress } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import UploadIcon from '@mui/icons-material/CloudUpload'; // or UploadFile
import StorefrontIcon from '@mui/icons-material/Storefront';
import { Autocomplete } from '@mui/material';
import { Country, State, City } from 'country-state-city';
import {
  Container,
  Typography,
  Paper,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stepper,
  Step,
  StepLabel,
  Collapse,
  Card,
  CardContent,
  Chip,
  InputAdornment,
  Tooltip,
} from '@mui/material';
import {
  Add,
  Remove,
  ArrowBack,
  ExpandMore,
  ExpandLess,
} from '@mui/icons-material';
import { toast } from 'react-toastify';
import { motion } from 'framer-motion';

const company = JSON.parse(sessionStorage.getItem('companyDetails') || '{}');
const Companycurrency = company?.currency ?? '';
const steps = [
  'Select Hotel & Date',
  'Select Rooms',
  'Choose Package',
  'Guest & Payment',
  'Booking Voucher',
];

export default function ManageInventory() {
  const [step, setStep] = useState(1);
  const [hotels, setHotels] = useState([]);
  const [rooms, setRooms] = useState([]);
  // roomnumber → display name (from the room master), shown on the tiles.
  const [roomNameMap, setRoomNameMap] = useState({});
  const [roomAvailability, setRoomAvailability] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState('');
  const [checkInDate, setCheckInDate] = useState('');
  const [checkOutDate, setCheckOutDate] = useState('');
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [selectedPkg, setSelectedPkg] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [addons, setAddons] = useState([{ name: '', price: '' }]);
  const [discount, setDiscount] = useState({ type: '%', value: '' });
  const [bookingData, setBookingData] = useState(null);
  const [desiredFinalPrice, setDesiredFinalPrice] = useState('');
  const allCountries = Country.getAllCountries();
  // Guest Details
  const [childCount, setChildCount] = useState(0);
  const [adultCount, setAdultCount] = useState(1);
  const [bookingRemark, setBookingRemark] = useState('');
  const [isCustomerFinalWithGST, setIsCustomerFinalWithGST] = useState(false);
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [ocrLoading, setOcrLoading] = useState(false);
  const [customerGSTBreakup, setCustomerGSTBreakup] = useState({
    base: 0,
    gst: 0,
  });
  const [cities, setCities] = useState({});

  /* ==============================================================
     🆕 AGENT / OTA BOOKING — NEW STATES (existing flow untouched)
     -- Naye naam use kiye taaki existing `bookingSource`
        (WalkIn/Agent) flow se koi conflict na ho.
  ============================================================== */
  const [throughAgentOpen, setThroughAgentOpen] = useState(false);
  // 'Direct' = normal booking | 'OTA' = agent/OTA booking active
  const [otaBookingSource, setOtaBookingSource] = useState('Direct');
  const [agentBooking, setAgentBooking] = useState({
    agentId: '',
    bookingPriceWithGST: '',
    propertyPrice: '',
    commission: 0,
  });

  const handleStateChange = (stateCode, index) => {
    const g = [...guests];
    g[index].state = stateCode;
    g[index].city = '';
    setGuests(g);

    const countryCode = Country.getAllCountries().find(
      (c) => c.name === g[index].country,
    )?.isoCode;

    const cityList = City.getCitiesOfState(countryCode, stateCode);

    setCities((prev) => ({
      ...prev,
      [index]: cityList,
    }));
  };
  const [guests, setGuests] = useState([
    {
      title: 'Mr',
      dob: '',
      age: '',
      nationality: 'Native',
      country: 'India',
      firstName: '',
      lastName: '',
      email: '',
      mobileNumber: '',
      address: '',
      city: '',
      state: '',
      idType: 'Aadhar Card',
      passportNumber: '',
      visaNumber: '',
      idName: '',
      idNumber: '',
      idPhotos: [],
    },
  ]);
  // Company Details
  const [companyForm, setCompanyForm] = useState({
    companyName: '',
    gstNo: '',
    address: '',
    city: '',
    state: '',
    mobileNumber: '',
    email: '',
  });
  const url = `${config.API_BASE_URL}${config.PRODUCT_LIST_API}`;
  const [billingType, setBillingType] = useState('Customer');
  const [companyFormOpen, setCompanyFormOpen] = useState(false);

  const [guestFormErrors, setGuestFormErrors] = useState({});
  const [companyFormErrors, setCompanyFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  // Hard guard against double-submit creating duplicate bookings. A ref (not
  // state) because it updates synchronously — `disabled={loading}` alone can't
  // stop a fast second click that fires before React re-renders.
  const bookingInFlightRef = useRef(false);
  const [priceModalOpen, setPriceModalOpen] = useState(false);
  const [priceOptions, setPriceOptions] = useState([]);

  // Step Errors
  const [stepErrors, setStepErrors] = useState({});

  // PAYMENT MODE
  const [paymentModeError, setPaymentModeError] = useState('');
  const [globalErrors, setGlobalErrors] = useState([]);
  const [allAddons, setAllAddons] = useState([]);
  const [selectedAddonIds, setSelectedAddonIds] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [paidAmount, setPaidAmount] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [payments, setPayments] = useState([
    { mode: '', amount: '', referenceNo: '', cardType: '', cardNumber: '' },
  ]);
  // 🆕 OTA booking active flag
  const isOtaBooking =
    otaBookingSource === 'OTA' &&
    Number(agentBooking.bookingPriceWithGST || 0) > 0;


  const roomPricePerNight = React.useMemo(() => {
  return Number(selectedPrice?.price || 0);
}, [selectedPrice]);


  // ---------------- GST RATE (MUST BE ABOVE useEffect) ----------------

  // Coupon states
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [couponDiscount, setCouponDiscount] = useState(0);

  // ---------------- BASIC COUNTS ----------------
  const qty = selectedRooms.length;
  const nights = calculateNights();

  // ---------------- ADDONS TOTAL ----------------
  const addonTotal = Math.round(
    selectedAddons.reduce(
      (sum, a) => sum + Number(a.price || 0) * Number(a.qty || 1),
      0,
    ),
  );

  // ---------------- TOTAL PAID ----------------
  const totalPaid = Math.round(
    payments.reduce((sum, p) => sum + Number(p.amount || 0), 0),
  );

  const [bookingSource, setBookingSource] = useState('WalkIn'); // WalkIn | Agent
  const [agents, setAgents] = useState([]);
  const [agentDetails, setAgentDetails] = useState({
    agentId: '',
    referenceNo: '',
    remark: '',
  });

  const isCustomerOverride = desiredFinalPrice && isCustomerFinalWithGST;

  /* --------------------------------------------------------------
     INITIAL SETUP
  -------------------------------------------------------------- */
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const tomorrow = new Date(Date.now() + 86400000)
      .toISOString()
      .split('T')[0];
    setCheckInDate(today);
    setCheckOutDate(tomorrow);
    fetchHotels();
    fetchAllAddons();
  }, []);

  useEffect(() => {
    if (hotels.length > 0 && !selectedHotel) {
      setSelectedHotel(hotels[0].id);
    }
  }, [hotels]);

  // Calendar "Book Room" prefill: set dates, pre-tick the room, then auto-drive
  // the wizard (load room types -> select the room's type -> load packages) so
  // it lands directly on Choose Package. Each step waits on its own effect so it
  // reads fresh state (no stale-closure bugs). Falls back gracefully (stops on
  // the room list) if room type is missing/no match, so manual flow never breaks.
  const location = useLocation();
  const bookingPrefillRef = useRef(false);
  const [prefillStage, setPrefillStage] = useState(null); // null|await|rooms|packages

  useEffect(() => {
    const pf = location.state?.prefill;
    if (!pf || bookingPrefillRef.current) return;
    bookingPrefillRef.current = true;
    if (pf.checkInDate) setCheckInDate(pf.checkInDate);
    if (pf.checkOutDate) setCheckOutDate(pf.checkOutDate);
    if (pf.roomNumber != null && pf.roomNumber !== '') {
      setSelectedRooms([Number(pf.roomNumber)]);
    }

    // #10: "Book Again" from the Guest Report sends the past booking's guest
    // details here — pre-fill the primary guest + company billing so the user
    // only picks dates / room / price. Only the guest form is touched.
    if (pf.guest) {
      const b = pf.guest;
      const parts = (b.guestName || '').trim().split(/\s+/);
      setGuests((prev) => {
        const g = [...prev];
        g[0] = {
          ...g[0],
          firstName: parts[0] || g[0].firstName,
          lastName: parts.slice(1).join(' ') || g[0].lastName,
          mobileNumber: b.mobile || g[0].mobileNumber,
          email: b.email || g[0].email,
          address: b.address || g[0].address,
          city: b.city || g[0].city,
          idType: b.idType || g[0].idType,
          idNumber: b.idNumber || g[0].idNumber,
        };
        return g;
      });
      if (b.companyName || b.gstNo) {
        setCompanyForm((cf) => ({
          ...cf,
          companyName: b.companyName || cf.companyName,
          gstNo: b.gstNo || cf.gstNo,
        }));
      }
    }

    setPrefillStage('await');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // Hotel auto-selected + dates ready -> load the room-type list.
  useEffect(() => {
    if (prefillStage !== 'await') return;
    if (selectedHotel && checkInDate && checkOutDate) {
      fetchRooms();
      setPrefillStage('rooms');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefillStage, selectedHotel, checkInDate, checkOutDate]);

  // Room-type list loaded -> select the clicked room's type.
  useEffect(() => {
    if (prefillStage !== 'rooms' || !rooms.length) return;
    const pf = location.state?.prefill;
    const want = (pf?.roomType || '').toString().trim().toLowerCase();
    const match = want
      ? rooms.find(
          (r) => (r.roomType || '').toString().trim().toLowerCase() === want,
        )
      : null;
    if (match) {
      selectRoom(match);
      setPrefillStage('packages');
    } else {
      setPrefillStage(null);
      toast.info('Dates & room pre-filled - choose the room type to continue.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefillStage, rooms]);

  // Room type selected (now on Select Rooms) -> fetch packages and jump to
  // Choose Package. The room is already pre-ticked above.
  useEffect(() => {
    if (prefillStage !== 'packages' || !selectedRoom || step !== 1.5) return;
    fetchPackages();
    setPrefillStage(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefillStage, selectedRoom, step]);

  useEffect(() => {
    // 🔥 if customer final price is not entered → do nothing
    if (!desiredFinalPrice) return;

    if (!roomPricePerNight || qty <= 0 || nights <= 0) return;

    const desiredRoomTotal = Number(desiredFinalPrice);
    const originalRoomBase = roomPricePerNight * qty * nights;

    if (desiredRoomTotal >= originalRoomBase) {
      setDiscount((prev) => ({
        ...prev,
        value: '0',
      }));
      return;
    }

    const requiredDiscountAmount = originalRoomBase - desiredRoomTotal;

    if (discount.type === '%') {
      const percent = (requiredDiscountAmount / originalRoomBase) * 100;

      setDiscount({
        type: '%',
        value: percent.toFixed(2),
      });
    } else {
      setDiscount({
        type: 'Rs',
        value: requiredDiscountAmount.toFixed(2),
      });
    }
  }, [desiredFinalPrice, roomPricePerNight, qty, nights]);

  // const addonGstRate = React.useMemo(() => {
  //   if (addonTotal > 0) return 5;
  //   return 0;
  // }, [addonTotal]);
const addonGstRate = React.useMemo(() => {
  if (isOtaBooking) return 0; // ← No addon GST for OTA
  if (addonTotal > 0) return 5;
  return 0;
}, [isOtaBooking, addonTotal]);
  // Add-on prices are GST-INCLUSIVE, so addonTotal already contains the tax.
  // Extract the GST portion for display (gross × rate / (100 + rate)) instead
  // of adding it on top — adding it inflated an inclusive 2900 to 3045.
  const addonGST = Math.round((addonTotal * addonGstRate) / (100 + addonGstRate));

  useEffect(() => {
    if (bookingSource === 'Agent') {
      fetchAgents();
    }
  }, [bookingSource]);

  // 🆕 Load agents as soon as the OTA modal opens (if not already loaded)
  useEffect(() => {
    if (throughAgentOpen && agents.length === 0) {
      fetchAgents();
    }
  }, [throughAgentOpen]);

  useEffect(() => {
    fetchCoupons();
  }, []);

  async function fetchAgents() {
    try {
      const token = sessionStorage.getItem('token');
      const res = await fetch(
        `${config.API_BASE_URL}/Home/GetallAgent/${encodeURIComponent(company?.id)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const data = await res.json();
      if (Array.isArray(data)) setAgents(data);
    } catch (err) {
      toast.error('Failed to load agents');
    }
  }

  /* ==============================================================
     🆕 AGENT BOOKING — Commission auto-calc + Apply handlers
  ============================================================== */
  const handleAgentBookingChange = (field, value) => {
    setAgentBooking((prev) => {
      const updated = { ...prev, [field]: value };

      // Live commission = Booking Price With GST - Property Price
      const bp = Number(
        field === 'bookingPriceWithGST' ? value : prev.bookingPriceWithGST,
      ) || 0;
      const pp = Number(
        field === 'propertyPrice' ? value : prev.propertyPrice,
      ) || 0;

      updated.commission = Math.max(Math.round(bp - pp), 0);
      return updated;
    });
  };

  const handleApplyAgentBooking = () => {
    // Validations
    if (!agentBooking.agentId) {
      toast.warn('Please select an agent');
      return;
    }
    if (
      !agentBooking.bookingPriceWithGST ||
      Number(agentBooking.bookingPriceWithGST) <= 0
    ) {
      toast.warn('Please enter Booking Price With GST');
      return;
    }
    if (
      !agentBooking.propertyPrice ||
      Number(agentBooking.propertyPrice) < 0
    ) {
      toast.warn('Please enter Property Price');
      return;
    }
    if (
      Number(agentBooking.propertyPrice) >
      Number(agentBooking.bookingPriceWithGST)
    ) {
      toast.warn('Property Price cannot be greater than Booking Price');
      return;
    }

    // 🔥 CORE: Feed Booking Price With GST into the existing final-price
    // pipeline. This way GST reverse-calc, payment, summary, and invoice
    // will all automatically run on this amount — no new calc logic.
    setOtaBookingSource('OTA');
    setDesiredFinalPrice(String(agentBooking.bookingPriceWithGST));
    setIsCustomerFinalWithGST(true);

    // Also set the booking source to Agent (reusing the existing field)
    setBookingSource('Agent');
    setAgentDetails((prev) => ({
      ...prev,
      agentId: agentBooking.agentId,
    }));

    setThroughAgentOpen(false);
    toast.success('Agent booking applied. Proceeding to guest details...');

    // Guest & Payment step pe le jao
    setStep(3);
  };

  const handleClearAgentBooking = () => {
    setOtaBookingSource('Direct');
    setAgentBooking({
      agentId: '',
      bookingPriceWithGST: '',
      propertyPrice: '',
      commission: 0,
    });
    setDesiredFinalPrice('');
    setIsCustomerFinalWithGST(false);
    setBookingSource('WalkIn');
    setAgentDetails({ agentId: '', referenceNo: '', remark: '' });
    toast.info('Agent booking cleared');
  };

  // Opens a print-only window for the guest registration form. When
  // `filled=true` the bound booking values are stamped into the fields;
  // when false the form prints empty so a walk-in guest can fill it by
  // hand. Uses a detached iframe so the rest of the page chrome is never
  // part of the printout.
  const openBookingFormPrint = (filled) => {
    const hotel =
      hotels?.find((h) => String(h.id) === String(selectedHotel)) || {};
    const g = filled ? guests?.[0] || {} : {};
    const stayQty = qty || (selectedRooms?.length ?? '');
    const stayNights = filled ? nights : '';
    const checkInStr = filled && checkInDate ? new Date(checkInDate).toLocaleString('en-GB') : '';
    const checkOutStr = filled && checkOutDate ? new Date(checkOutDate).toLocaleString('en-GB') : '';
    const rooms = filled ? (selectedRooms || []).join(', ') : '';
    const roomType = filled ? selectedRoom?.roomType || '' : '';
    const pkgName = filled ? selectedPkg?.packageName || '' : '';
    const adults = filled ? adultCount : '';
    const children = filled ? childCount : '';
    const totalAmt = filled ? Number(finalAfterCoupon || 0).toFixed(2) : '';
    const paidAmt = filled ? Number(totalPaid || 0).toFixed(2) : '';
    const dueAmt =
      filled ? Number(Math.max(0, finalAfterCoupon - totalPaid) || 0).toFixed(2) : '';
    const payMode = filled ? paymentMode || '' : '';
    const company = filled ? companyForm.companyName || '' : '';
    const gst = filled ? companyForm.gstNo || '' : '';

    const esc = (v) =>
      (v ?? '')
        .toString()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    const cell = (label, value, w) => `
      <div class="cell" style="${w ? `width:${w}` : ''}">
        <div class="lbl">${label}</div>
        <div class="val">${esc(value)}</div>
      </div>`;

    const html = `<!DOCTYPE html><html><head>
<title>Guest Registration Form</title>
<style>
  @page { size: A4; margin: 12mm 10mm; }
  * { box-sizing: border-box; }
  body { font-family: Arial, sans-serif; color: #000; font-size: 11px; margin: 0; }
  h1 { font-size: 16px; margin: 0; text-align: center; letter-spacing: 1px; }
  .hdr { display:flex; align-items:center; gap:10px; border-bottom: 2px solid #000; padding-bottom: 8px; margin-bottom: 8px; }
  .hdr .info { flex:1; }
  .hdr .info .h-name { font-size: 14px; font-weight: 700; }
  .hdr .info .h-meta { font-size: 10px; color:#333; }
  .title { text-align: center; font-weight: 700; font-size: 13px; margin: 8px 0 10px; letter-spacing: 3px; }
  .section { border: 1px solid #000; margin-bottom: 6px; }
  .section-title { background:#eee; padding:3px 6px; font-weight:700; font-size:11px; border-bottom:1px solid #000; }
  .row { display:flex; }
  .cell { flex:1; padding:4px 6px; border-right:1px solid #000; border-bottom:1px solid #000; min-height:32px; }
  .cell:last-child { border-right:none; }
  .row:last-child .cell { border-bottom:none; }
  .lbl { font-size:8.5px; color:#333; text-transform:uppercase; letter-spacing:0.4px; }
  .val { font-size:12px; min-height:14px; padding-top:1px; }
  .sign-row { display:flex; gap:12px; margin-top:14px; }
  .sign-box { flex:1; border-top:1px solid #000; padding-top:4px; text-align:center; font-size:10px; }
  .declaration { font-size:9.5px; line-height:1.4; margin-top:10px; padding:6px; border:1px solid #000; }
</style></head>
<body>
  <div class="hdr">
    <div class="info">
      <div class="h-name">${esc(hotel.hotelName || hotel.HotelName || '')}</div>
      <div class="h-meta">${esc(hotel.address || hotel.Address || '')}${hotel.city ? ', ' + esc(hotel.city) : ''}${hotel.pincode ? ' - ' + esc(hotel.pincode) : ''}</div>
      <div class="h-meta">Phone: ${esc(hotel.mobile || hotel.Mobile || '')}${hotel.gstNumber || hotel.GstNumber ? '  ·  GST: ' + esc(hotel.gstNumber || hotel.GstNumber) : ''}</div>
    </div>
  </div>
  <div class="title">GUEST REGISTRATION FORM</div>

  <div class="section">
    <div class="section-title">STAY DETAILS</div>
    <div class="row">
      ${cell('Check-In', checkInStr)}
      ${cell('Check-Out', checkOutStr)}
      ${cell('Nights', stayNights)}
    </div>
    <div class="row">
      ${cell('Room No(s)', rooms)}
      ${cell('Room Type', roomType)}
      ${cell('Package', pkgName)}
    </div>
    <div class="row">
      ${cell('Rooms', stayQty)}
      ${cell('Adults', adults)}
      ${cell('Children', children)}
    </div>
  </div>

  <div class="section">
    <div class="section-title">PRIMARY GUEST</div>
    <div class="row">
      ${cell('Title', g.title)}
      ${cell('First Name', g.firstName)}
      ${cell('Last Name', g.lastName)}
    </div>
    <div class="row">
      ${cell('Mobile Number', g.mobileNumber)}
      ${cell('Email', g.email)}
      ${cell('Nationality', g.nationality)}
    </div>
    <div class="row">
      ${cell('Date of Birth', g.dob)}
      ${cell('Age', g.age)}
      ${cell('Gender', g.gender)}
    </div>
    <div class="row">
      ${cell('Address', g.address)}
    </div>
    <div class="row">
      ${cell('City', g.city)}
      ${cell('State', g.state)}
      ${cell('Country', g.country)}
    </div>
    <div class="row">
      ${cell('ID Type', g.idType)}
      ${cell('ID Number', g.idNumber)}
      ${cell('ID Name', g.idName)}
    </div>
    <div class="row">
      ${cell('Passport Number', g.passportNumber)}
      ${cell('Visa Number', g.visaNumber)}
    </div>
  </div>

  <div class="section">
    <div class="section-title">PAYMENT</div>
    <div class="row">
      ${cell('Total Amount', totalAmt ? '₹ ' + totalAmt : '')}
      ${cell('Paid', paidAmt ? '₹ ' + paidAmt : '')}
      ${cell('Due', dueAmt ? '₹ ' + dueAmt : '')}
    </div>
    <div class="row">
      ${cell('Payment Mode', payMode)}
      ${cell('Company / GST', company || gst ? `${company}${gst ? ' / ' + gst : ''}` : '')}
    </div>
  </div>

  <div class="declaration">
    <b>Declaration:</b> I/We hereby declare that the information given above is true to the best of my knowledge. I/We agree to abide by the rules and regulations of the hotel during our stay. I/We am/are responsible for any damage to hotel property caused by me/my party during the stay.
  </div>

  <div class="sign-row">
    <div class="sign-box">Guest Signature</div>
    <div class="sign-box">Date</div>
    <div class="sign-box">Authorised Signatory</div>
  </div>
</body></html>`;

    const iframe = document.createElement('iframe');
    iframe.style.cssText =
      'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow || iframe.contentDocument;
    doc.document.open();
    doc.document.write(html);
    doc.document.close();
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => document.body.removeChild(iframe), 1000);
    }, 400);
  };

  const handleAadharOCR = async (frontFile, backFile) => {
    if (!frontFile || !backFile) {
      toast.error('Please upload both front and back Aadhaar images');
      return;
    }

    try {
      setOcrLoading(true);

      const formData = new FormData();

      // FILES
      formData.append('FrontImage', frontFile);
      formData.append('BackImage', backFile);

      // COMPANY ID
      formData.append('Companyid', company?.id);

      const response = await fetch(
        `${config.API_BASE_URL}/Home/GetUserIdData`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
          body: formData,
        },
      );

      // API ERROR
      if (!response.ok) {
        const errorText = await response.text();

        console.log('API ERROR RESPONSE:', errorText);

        toast.error('OCR API Failed');

        return;
      }

      const result = await response.json();

      console.log('OCR RESULT:', result);

      // SUCCESS CHECK
      if (result?.code === 200) {
        const front = result?.data?.front || {};
        const back = result?.data?.back || {};

        // =========================
        // NAME
        // =========================
        const fullName = front?.name || '';

        const nameParts = fullName.trim().split(' ');

        const firstName = nameParts[0] || '';

        const lastName =
          nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

        // =========================
        // DOB
        // =========================
        let formattedDob = '';

        if (front?.dob) {
          // 03/03/2000 -> 2000-03-03
          formattedDob = front.dob.split('/').reverse().join('-');
        }

        // =========================
        // ADDRESS
        // =========================
        const fullAddress = back?.address || '';

        const addressParts = fullAddress
          .split(',')
          .map((x) => x.trim())
          .filter(Boolean);

        console.log('ADDRESS PARTS:', addressParts);

        // =========================
        // COUNTRY
        // =========================
        const countryName = 'India';

        const countryCode = allCountries.find(
          (c) => c.name === countryName,
        )?.isoCode;

        // =========================
        // STATES
        // =========================
        const states = State.getStatesOfCountry(countryCode);

        let matchedState = null;

        // =========================
        // FIND STATE FROM ADDRESS
        // =========================
        for (const st of states) {
          const exists = addressParts.some((p) =>
            p.toLowerCase().includes(st.name.toLowerCase()),
          );

          if (exists) {
            matchedState = st;
            break;
          }
        }

        console.log('MATCHED STATE:', matchedState);

        // =========================
        // CITY
        // =========================
        let cityList = [];

        if (matchedState) {
          cityList = City.getCitiesOfState(countryCode, matchedState.isoCode);

          setCities((prev) => ({
            ...prev,
            0: cityList,
          }));
        }

        let matchedCity = null;

        // =========================
        // FIND CITY FROM ADDRESS
        // =========================
        for (const city of cityList) {
          const exists = addressParts.some((p) =>
            p.toLowerCase().includes(city.name.toLowerCase()),
          );

          if (exists) {
            matchedCity = city;
            break;
          }
        }

        console.log('MATCHED CITY:', matchedCity);

        // =========================
        // UPDATE GUEST
        // =========================
        setGuests((prev) => {
          const updated = [...prev];

          updated[0] = {
            ...updated[0],

            // NAME
            firstName: firstName,

            lastName: lastName,

            // DOB
            dob: formattedDob,

            // AGE
            age: formattedDob ? calculateAge(formattedDob) : '',

            // GENDER
            gender: front?.gender || '',

            // AADHAR NUMBER
            idNumber: front?.aadhaarNumber || '',

            // ADDRESS
            address: fullAddress,

            // COUNTRY
            country: countryName,

            // STATE
            state: matchedState ? matchedState.name : '',

            // CITY
            city: matchedCity ? matchedCity.name : '',

            // SAVE FILES
            frontImage: frontFile,

            backImage: backFile,
          };

          return updated;
        });

        toast.success('Aadhaar OCR Success');
      } else {
        console.log('OCR FAILED:', result);

        toast.error(result?.message || 'OCR Failed');
      }
    } catch (err) {
      console.log('OCR ERROR:', err);

      toast.error('OCR API Error');
    } finally {
      setOcrLoading(false);
    }
  };

  async function fetchCoupons() {
    try {
      const token = sessionStorage.getItem('token');
      const res = await fetch(
        `${config.API_BASE_URL}/Home/GetUnusedVoucher/${encodeURIComponent(company?.id)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const data = await res.json();
      if (Array.isArray(data)) setCoupons(data);
    } catch {
      toast.error('Failed to load coupons');
    }
  }

  const validateGuests = () => {
    if (!guests.length) return false;

    const primary = guests[0];

    // Only name + mobile are mandatory at booking time. ID type / ID number
    // and other details can be filled later at check-in via the Bookings
    // Update flow.
    if (
      !primary.firstName?.trim() ||
      !/^\d{10}$/.test(primary.mobileNumber || '')
    ) {
      return false;
    }

    return true;
  };

  const discountPerRoomPerNight = React.useMemo(() => {
    if (!roomPricePerNight || !discount?.value) return 0;

    if (discount.type === '%') {
      return (roomPricePerNight * Number(discount.value || 0)) / 100;
    }

    const totalUnits = qty * nights;
    if (totalUnits <= 0) return 0;

    const perUnitDiscount = Number(discount.value || 0) / totalUnits;
    return Math.min(perUnitDiscount, roomPricePerNight);
  }, [roomPricePerNight, discount, qty, nights]);

  const effectiveRoomPricePerNight = React.useMemo(() => {
    return Math.max(roomPricePerNight - discountPerRoomPerNight, 0);
  }, [roomPricePerNight, discountPerRoomPerNight]);

  // const gstRate = React.useMemo(() => {
  //   if (effectiveRoomPricePerNight >= 7500) return 18;
  //   if (effectiveRoomPricePerNight > 0) return 5;
  //   return 0;
  // }, [effectiveRoomPricePerNight]);
// const gstRate = React.useMemo(() => {
//   if (isOtaBooking && !selectedPrice) {
//     const bookingPriceWithGST = Number(agentBooking.bookingPriceWithGST || 0);
//     const qty_ = selectedRooms.length;
//     const nights_ = calculateNights();
//     if (bookingPriceWithGST > 0 && qty_ > 0 && nights_ > 0) {
//       // Try 18% first: base = price / 1.18, check slab
//       const baseAt18 = bookingPriceWithGST / 1.18;
//       const perRoomAt18 = baseAt18 / (qty_ * nights_);
//       if (perRoomAt18 >= 7500) return 18;

//       // Try 5%: base = price / 1.05, check slab
//       const baseAt5 = bookingPriceWithGST / 1.05;
//       const perRoomAt5 = baseAt5 / (qty_ * nights_);
//       if (perRoomAt5 > 0) return 5;
//     }
//     return 0;
//   }
//   if (effectiveRoomPricePerNight >= 7500) return 18;
//   if (effectiveRoomPricePerNight > 0) return 5;
//   return 0;
// }, [isOtaBooking, selectedPrice, agentBooking.bookingPriceWithGST, selectedRooms, effectiveRoomPricePerNight]);
const gstRate = React.useMemo(() => {
  if (!isGstApplicable()) return 0; // ← Company GST switch OFF → no GST at all
  if (isOtaBooking) return 0; // ← No GST for agent/OTA bookings
  // The GST slab must match what the CHECKOUT recalculation uses — checkout
  // keys the slab off the final (incl-GST) price per night. With a customer
  // final-price override, decide the slab from THAT final/night too; otherwise
  // booking computed 5% while checkout used 18% (>7875), inflating the amount
  // at checkout. >= 7875/night → 18%, else 5%.
  if (isCustomerOverride && qty > 0 && nights > 0) {
    // Override price is already the WITH-GST per night — compare directly.
    const finalPerNight = Number(desiredFinalPrice || 0) / qty / nights;
    if (finalPerNight >= 7875) return 18;
    if (finalPerNight > 0) return 5;
    return 0;
  }
  // Non-override: effectiveRoomPricePerNight is the PRE-GST base. The slab keys
  // off the WITH-GST price (like checkout). The customer-facing price at the
  // lower 5% slab is base*1.05 — if THAT reaches the 7875 cut-off it's an 18%
  // room. Comparing the bare base booked 7500-7875 rooms at 5% while checkout
  // re-billed them at 18% (the amount "bigad jata" tha at invoice).
  const base = Number(effectiveRoomPricePerNight || 0);
  if (base * 1.05 >= 7875) return 18;
  if (base > 0) return 5;
  return 0;
}, [isOtaBooking, isCustomerOverride, desiredFinalPrice, qty, nights, effectiveRoomPricePerNight]);

// Add this derived display value after gstRate memo:
// const displayRatePerRoomNight = React.useMemo(() => {
//   if (isOtaBooking && !selectedPrice) {
//     const bookingPriceWithGST = Number(agentBooking.bookingPriceWithGST || 0);
//     const qty_ = selectedRooms.length;
//     const nights_ = calculateNights();
//     if (bookingPriceWithGST > 0 && qty_ > 0 && nights_ > 0) {
//       const base = gstRate > 0
//         ? bookingPriceWithGST / (1 + gstRate / 100)
//         : bookingPriceWithGST;
//       return base / (qty_ * nights_);
//     }
//     return 0;
//   }
//   return roomPricePerNight;
// }, [isOtaBooking, selectedPrice, agentBooking.bookingPriceWithGST, selectedRooms, gstRate, roomPricePerNight]);
  /* --------------------------------------------------------------
     HELPERS
  -------------------------------------------------------------- */
  function calculateNights() {
    if (!checkInDate || !checkOutDate) return 0;
    const checkIn = new Date(checkInDate);
    const checkOut = new Date(checkOutDate);
    const diffTime = Math.abs(checkOut - checkIn);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  // --- VALIDATIONS WITH ALERT COLLECTION ---
  const validateAllSteps = () => {
    let errors = [];

    // Step 1 validation
    if (!selectedHotel) errors.push('Please select a hotel');
    if (!checkInDate) errors.push('Check-in date is required');
    if (!checkOutDate) errors.push('Check-out date is required');
    if (checkInDate && checkOutDate && checkOutDate <= checkInDate)
      errors.push('Check-out must be after check-in');

    // Step 1.5
    if (selectedRooms.length === 0)
      errors.push('Please select at least one available room');

    // Step 2 — package is not required for agent/OTA booking
    if (!isOtaBooking) {
      if (!selectedPkg) errors.push('Please select a package');
      if (!selectedPrice) errors.push('Please select a package price');
    }

    // Guest Details — only name + mobile are mandatory at booking time. All
    // other ID/personal fields can be filled later at check-in.
    if (!guests[0].firstName.trim())
      errors.push('Guest first name is required');
    if (!/^\d{10}$/.test(guests[0].mobileNumber))
      errors.push('Guest mobile number must be 10 digits');

    // Billing type company fields
    if (billingType === 'Company') {
      if (!companyForm.companyName.trim())
        errors.push('Company name is required');
      if (!companyForm.gstNo.trim()) errors.push('GST number is required');
      if (!companyForm.address.trim())
        errors.push('Company address is required');
      if (!companyForm.city.trim()) errors.push('Company city is required');
      if (!companyForm.state.trim()) errors.push('Company state is required');
      if (!companyForm.mobileNumber.trim())
        errors.push('Company mobile number is required');
      if (!companyForm.email.trim()) errors.push('Company email is required');
    }

    // Card number / type and Online-UPI reference are optional — only
    // name + mobile (and Company fields when billing to a company) gate a
    // booking. Payment details can be completed later from Bookings → Update.

    // Final
    setGlobalErrors(errors);
    return errors.length === 0;
  };

  const addPaymentRow = () => {
    setPayments([
      ...payments,
      { mode: '', amount: '', referenceNo: '', cardType: '', cardNumber: '' },
    ]);
  };

  const removePaymentRow = (index) => {
    const updated = [...payments];
    updated.splice(index, 1);
    setPayments(updated);
  };

  const handlePaymentChange = (index, field, value) => {
    const updated = [...payments];
    updated[index][field] = value;
    setPayments(updated);
  };
  // const finalPricePerRoomPerNight = React.useMemo(() => {
  //   if (isCustomerOverride) {
  //     const customerFinal = Number(desiredFinalPrice || 0);
  //     if (customerFinal <= 0 || qty <= 0 || nights <= 0) return 0;

  //     const baseWithoutGST =
  //       gstRate > 0 ? customerFinal / (1 + gstRate / 100) : customerFinal;

  //     return baseWithoutGST / (qty * nights);
  //   }

  //   return effectiveRoomPricePerNight;
  // }, [
  //   isCustomerOverride,
  //   desiredFinalPrice,
  //   gstRate,
  //   qty,
  //   nights,
  //   effectiveRoomPricePerNight,
  // ]);

  const finalPricePerRoomPerNight = React.useMemo(() => {
  if (isCustomerOverride) {
    const customerFinal = Number(desiredFinalPrice || 0);
    if (customerFinal <= 0 || qty <= 0 || nights <= 0) return 0;

    // OTA: no GST reverse-calc — full amount is the base price
    const baseWithoutGST =
      !isOtaBooking && gstRate > 0
        ? customerFinal / (1 + gstRate / 100)
        : customerFinal;

    return baseWithoutGST / (qty * nights);
  }
  return effectiveRoomPricePerNight;
}, [isCustomerOverride, isOtaBooking, desiredFinalPrice, gstRate, qty, nights, effectiveRoomPricePerNight]);

  const basePrice = Math.round(finalPricePerRoomPerNight * qty * nights);

  /* --------------------------------------------------------------
     VALIDATIONS
  -------------------------------------------------------------- */
  const validateStep1 = () => {
    const errors = {};
    if (!selectedHotel) errors.hotel = 'Please select a hotel';
    if (!checkInDate) errors.checkIn = 'Check-in date is required';
    if (!checkOutDate) errors.checkOut = 'Check-out date is required';
    if (checkInDate && checkOutDate && checkOutDate <= checkInDate) {
      errors.checkOut = 'Check-out must be after check-in';
    }
    setStepErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateStep15 = () => {
    if (selectedRooms.length === 0) {
      toast.warn('Please select at least one room');
      return false;
    }
    return true;
  };

  const validateStep2 = () => {
    if (!selectedPkg || !selectedPrice) {
      toast.warn('Please select a package and price');
      return false;
    }
    return true;
  };

  const validateForms = () => {
    const guestErrors = {};
    const companyErrors = {};
    let payModeError = '';

    // Guest Validation — only name + mobile are mandatory at booking time.
    // ID type/number, passport/visa, etc. can be filled later at check-in.
    if (!guests[0].firstName?.trim()) guestErrors.firstName = 'Required';
    if (!/^\d{10}$/.test(guests[0].mobileNumber || ''))
      guestErrors.mobileNumber = 'Invalid mobile (10 digits)';
    // Keep the foreign-guest field reset so stale Native ID values don't
    // accidentally save on a foreign booking.
    if (guests[0].nationality !== 'Native') {
      guests[0].idType = '';
      guests[0].idNumber = '';
    }

    // Company Validation
    if (billingType === 'Company') {
      if (!companyForm.companyName?.trim())
        companyErrors.companyName = 'Required';
      if (!companyForm.gstNo?.trim()) companyErrors.gstNo = 'Required';
      if (!companyForm.address?.trim()) companyErrors.address = 'Required';
      if (!companyForm.city?.trim()) companyErrors.city = 'Required';
      if (!companyForm.state) companyErrors.state = 'Required';
      if (!/^\d{10}$/.test(companyForm.mobileNumber || ''))
        companyErrors.mobileNumber = 'Invalid mobile (10 digits)';
      if (!companyForm.email?.trim()) companyErrors.email = 'Required';
    }

    // Payment Validation
    // 🔥 Skip payment validation if final payable amount is ZERO
    if (finalAfterCoupon > 0) {
      payments.forEach((p, index) => {
        // 🔥 NEW: Amount is present but mode is missing
        if (p.amount && !p.mode) {
          payModeError =
            payModeError || `Payment mode required in row ${index + 1}`;
        }

        // 🔥 NEW: Mode is present but amount is missing
        if (p.mode && !p.amount) {
          payModeError =
            payModeError || `Payment amount required in row ${index + 1}`;
        }

        // Per product decision: only mode + amount are required together.
        // Card number / type and UPI-Online reference are optional now —
        // they can be added later from Bookings → Update. (Previously a
        // missing card number / reference silently blocked the booking.)
      });
    } else {
      // ✅ 100% coupon / zero payable case
      payModeError = ''; // clear any previous errors
    }

    // Set error states
    setGuestFormErrors(guestErrors);
    setCompanyFormErrors(companyErrors);
    setPaymentModeError(payModeError);

    // If any errors → Show correct alerts
    if (
      Object.keys(guestErrors).length > 0 ||
      (billingType === 'Company' && Object.keys(companyErrors).length > 0) ||
      payModeError
    ) {
      let allErrors = [];

      Object.keys(guestErrors).forEach((key) => {
        allErrors.push(
          `Guest ${key.replace(/([A-Z])/g, ' $1')}: ${guestErrors[key]}`,
        );
      });

      if (billingType === 'Company') {
        Object.keys(companyErrors).forEach((key) => {
          allErrors.push(
            `Company ${key.replace(/([A-Z])/g, ' $1')}: ${companyErrors[key]}`,
          );
        });
      }

      if (payModeError) allErrors.push(payModeError);

      // Also push into the top red error box. Previously these only went to
      // toasts (which the user often never saw) while the page scrolled to
      // the top — so a failing payment/guest field silently bounced the user
      // up with no visible reason. Now the box at the top spells it out.
      setGlobalErrors(allErrors);
      allErrors.forEach((e) => toast.error(e));
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    // Cleared so a previous run's red box doesn't linger after a fix.
    setGlobalErrors([]);
    return true;
  };

  const calculateAge = (dob) => {
    if (!dob) return '';

    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  /* --------------------------------------------------------------
     API CALLS
  -------------------------------------------------------------- */
  async function fetchHotels() {
    setLoading(true);
    try {
      const token = sessionStorage.getItem('token');
      const res = await fetch(
        `${config.API_BASE_URL}/Home/GetHotelsdropdown/${company?.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const data = await res.json();
      if (Array.isArray(data)) setHotels(data);
    } catch (err) {
      toast.error('Failed to load hotels');
    }
    setLoading(false);
  }

  async function fetchRooms() {
    if (!validateStep1()) return;
    setLoading(true);
    try {
      const token = sessionStorage.getItem('token');
      const res = await fetch(
        `${config.API_BASE_URL}/Home/getRoomsByHotel/${selectedHotel}?id=${company?.id}&date=${checkInDate}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const data = await res.json();
      if (Array.isArray(data)) setRooms(data);

      // Room display names live in the room master — build a roomnumber→name
      // map for this hotel so named rooms show their name (not just a number).
      try {
        const mRes = await fetch(
          `${config.API_BASE_URL}/Home/GetAllRoom/${company?.id}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        const master = await mRes.json();
        const map = {};
        (Array.isArray(master) ? master : []).forEach((r) => {
          if (r.roomName && Number(r.hotelid) === Number(selectedHotel))
            map[r.roomnumber] = r.roomName;
        });
        setRoomNameMap(map);
      } catch {
        /* names optional — fall back to numbers */
      }
    } catch (err) {
      toast.error('Failed to load rooms');
    }
    setLoading(false);
  }

  async function fetchGuestByMobile(mobile) {
    if (!mobile || mobile.length !== 10) return;

    try {
      const token = sessionStorage.getItem('token');

      const res = await fetch(
        `${config.API_BASE_URL}/Home/GetGuestByMobile/${mobile}?companyId=${company?.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = await res.json();
      console.log('Userdata', data);

      if (data) {
        // ✅ country API se lo, fallback guests[0]
        const selectedCountry = data.country || guests[0].country;

        const countryCode = allCountries.find(
          (c) => c.name === selectedCountry,
        )?.isoCode;

        // ✅ safe fallback
        const states = State.getStatesOfCountry(countryCode || '');

        // ✅ state match
        const stateObj = states.find(
          (s) => s.name.toLowerCase() === (data.state || '').toLowerCase(),
        );

        let cityList = [];

        // ✅ cities fetch
        if (stateObj) {
          cityList = City.getCitiesOfState(countryCode, stateObj.isoCode);

          // 🔥 IMPORTANT FIX (multi guest safe)
          setCities((prev) => ({
            ...prev,
            0: cityList,
          }));
        }

        // ✅ city match
        const cityObj = cityList.find(
          (c) => c.name.toLowerCase() === (data.city || '').toLowerCase(),
        );

        // ✅ update guest
        setGuests((prev) => {
          const g = [...prev];

          g[0] = {
            ...g[0],
            country: selectedCountry, // 🔥 missing tha
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            email: data.email || '',
            address: data.address || '',
            state: stateObj ? stateObj.name : '',
            city: cityObj ? cityObj.name : '',
            idType: data.idType || 'Aadhar Card',
            idNumber: data.idNumber || '',
            dob: data.dob ? data.dob.split('T')[0] : '',

            age: data.age || '',
          };

          return g;
        });
      }
    } catch (err) {
      console.log('Guest fetch failed', err);
    }
  }

  async function selectRoom(room) {
    setSelectedRoom(room);
    const token = sessionStorage.getItem('token');
    const res = await fetch(
      `${config.API_BASE_URL}/Home/SelectRoom/${company?.id}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          hotelId: selectedHotel,
          roomType: room.roomType,
          date: checkInDate,
        }),
      },
    );
    const data = await res.json();
    if (Array.isArray(data)) setRoomAvailability(data);
    setStep(1.5);
  }

  async function fetchPackages() {
    if (!validateStep15()) return;
    try {
      const token = sessionStorage.getItem('token');
      const pkgUrl = `${config.API_BASE_URL}/Home/GetPackageReportforbookings?hotelId=${selectedHotel}&companyid=${company?.id}&roomTypeId=${selectedRoom.roomType}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}`;
      // Diagnostic: compare these lookup params (hotelId, roomTypeId, dates)
      // with the wizard's "[Wizard] CreatePackage payload" log. A package only
      // shows when hotelId + roomTypeId match AND the check-in/out dates fall
      // inside the package's fromDate–toDate window.
      console.log('[Booking] package lookup:', {
        hotelId: selectedHotel,
        roomTypeId: selectedRoom.roomType,
        checkInDate,
        checkOutDate,
      });
      const res = await fetch(pkgUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      console.log('[Booking] package response:', data);

      if (Array.isArray(data) && data.length > 0) {
        // 🔥 Calculate lowest price for each package
        const updatedData = data.map((pkg) => {
          const lowestPrice =
            pkg.memberWisePrices && pkg.memberWisePrices.length > 0
              ? Math.min(...pkg.memberWisePrices.map((m) => m.price))
              : null;

          return { ...pkg, lowestPrice }; // add new property
        });

        setPackages(updatedData);
        console.log('Updated Packages:', updatedData);
      } else {
        toast.warn('No packages found for selected room type');
      }

      setStep(2);
    } catch (err) {
      toast.error('Failed to fetch packages');
    }
  }

  // Fetch Addons from API
  async function fetchAllAddons() {
    try {
      const token = sessionStorage.getItem('token');

      const res = await fetch(
        `${config.API_BASE_URL}/Home/GetAlladdons/${encodeURIComponent(company?.id)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log('Response:', res);

      const data = await res.json();

      if (Array.isArray(data)) {
        setAllAddons(data);
      }

      console.log('Data:', data);
    } catch (err) {
      console.error('Fetch error:', err);
      toast.error('Failed to load addons');
    }
  }

  // Handle addon selection
  const handleAddonSelection = (selectedIds) => {
    setSelectedAddonIds(selectedIds);

    const selectedItems = allAddons
      .filter((a) => selectedIds.includes(a.id))
      .map((a) => ({
        ...a,
        qty: 1, // 👈 default quantity
      }));

    setSelectedAddons(selectedItems);
  };
  const updateAddonQty = (id, qty) => {
    setSelectedAddons((prev) =>
      prev.map((a) =>
        a.id === id ? { ...a, qty: Math.max(1, Number(qty)) } : a,
      ),
    );
  };

  const addAddon = () => setAddons([...addons, { name: '', price: '' }]);
  const removeAddon = (i) => setAddons(addons.filter((_, x) => x !== i));

  // 2️⃣ Final price per room per night ✅

  useEffect(() => {
    if (
      !desiredFinalPrice ||
      !isCustomerFinalWithGST ||
      qty <= 0 ||
      nights <= 0
    ) {
      setCustomerGSTBreakup({
        base: 0,
        gst: 0,
        perRoom: 0,
      });
      return;
    }

    const customerFinal = Number(desiredFinalPrice);

    // 🔁 Reverse GST
    const baseWithoutGST =
      gstRate > 0 ? customerFinal / (1 + gstRate / 100) : customerFinal;

    const gstAmount = customerFinal - baseWithoutGST;

    // 🏨 Per room / per night
    const perRoomPerNight = baseWithoutGST / (qty * nights);

    setCustomerGSTBreakup({
      base: Math.round(baseWithoutGST), // 👉 2850
      gst: Math.round(gstAmount), // 👉 150
      perRoom: Math.round(perRoomPerNight), // 👉 1425
    });
  }, [desiredFinalPrice, isCustomerFinalWithGST, gstRate, qty, nights]);

  // 3️⃣ Base price (after discount, without GST)

  // 5️⃣ GST calculation
  const calculateGST = () => {
    const finalWithGST = Math.round(basePrice * (1 + gstRate / 100));

    const totalGST = Math.round(finalWithGST - basePrice);
    const final =
      basePrice +
      totalGST + // Room GST
      addonTotal; // add-on total is GST-inclusive — don't add addonGST again

    const finalBalance = Math.round(final - totalPaid);

    return { totalGST, final, finalBalance, totalBase: basePrice };
  };

  // 6️⃣ Use GST values
  const { totalGST, final, finalBalance, totalBase } = calculateGST();
  const roomFinalWithGST = React.useMemo(() => {
    if (desiredFinalPrice && isCustomerFinalWithGST) {
      return Number(desiredFinalPrice);
    }
    return basePrice + totalGST;
  }, [desiredFinalPrice, isCustomerFinalWithGST, basePrice, totalGST]);

  const finalAmountWithGST = Math.round(
    roomFinalWithGST + addonTotal, // add-on total already GST-inclusive
  );

  // ---------------- FINAL TOTAL ----------------
  const totalPrice = Math.round(basePrice + totalGST + addonTotal);

  /* --------------------------------------------------------------
     BOOKING
  -------------------------------------------------------------- */
async function handleBooking() {
    // Block re-entry while a booking save is already in flight (double-click /
    // double-fire). Set true only at the actual submit (below), reset in the
    // finally — validation failures never touch it.
    if (bookingInFlightRef.current) return;
    console.log('handleBooking called', {
      selectedHotel,
      selectedRoom,
      selectedPkg,
      selectedPrice,
      selectedRooms,
      payments,
      discount,
      totalPrice,
      totalPaid,
      final,
      finalBalance,
      paymentMode,
      otaBookingSource,
      agentBooking,
    });

    if (!selectedHotel) {
      toast.error('Please select a hotel');
      setStep(1);
      return;
    }
    if (!selectedRoom) {
      toast.error('Please select a room');
      setStep(1.5);
      return;
    }

    if (!isOtaBooking) {
      if (!selectedPkg || !selectedPrice) {
        toast.warn('Please select a package and price');
        setStep(2);
        return;
      }
      if (!validateStep2()) {
        setStep(2);
        return;
      }
    }

    if (!validateForms()) return;
    if (!validateAllSteps()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      toast.error('Please fill all required fields!');
      return;
    }
    if (!validateGuests()) {
      toast.error('Please fill all mandatory details for Guest 1');
      return;
    }

    // ─────────────────────────────────────────────────────────────
    // 🔥 FIX: For OTA bookings, selectedPrice is null (package was
    //    skipped), so roomPricePerNight = 0.
    //    Derive a real OriginalPrice from agentBooking.propertyPrice
    //    by reversing GST and dividing by rooms × nights.
    // ─────────────────────────────────────────────────────────────
    const nightsVal = nights || calculateNights();

    let resolvedOriginalPrice; // price per room per night, before discount, without GST
    let resolvedPriceWithoutDiscount; // total original base (rooms × nights), no GST

if (isOtaBooking && !selectedPrice) {
  // GST = 0 for OTA, so full booking amount IS the base price
  const bookingPrice = Number(agentBooking.bookingPriceWithGST || 0);
  resolvedOriginalPrice =
    qty > 0 && nightsVal > 0 ? bookingPrice / (qty * nightsVal) : 0;
  resolvedPriceWithoutDiscount = bookingPrice;
} else {
      resolvedOriginalPrice = Number(roomPricePerNight || 0);
      resolvedPriceWithoutDiscount = Math.round(
        roomPricePerNight * qty * nightsVal,
      );
    }

    const filteredGuests = guests.filter((g, index) => {
      if (index === 0) return true;
      return g.firstName || g.mobileNumber;
    });

    const roomId = Number(
      selectedRoom.roomId || selectedRoom.roomId === 0
        ? selectedRoom.roomId
        : NaN,
    );
    if (Number.isNaN(roomId)) {
      toast.error('Invalid room selected');
      return;
    }

    const pkgId = isOtaBooking
      ? Number(selectedPkg?.packageId || 0)
      : Number(selectedPkg?.packageId || NaN);

    const selPrice = selectedPrice || {};

    const selectedAgentObj = agents.find(
      (a) => String(a.id) === String(agentBooking.agentId),
    );

    // Never write a booking row with userid 0; recover the session first.
    const uid = requireUserId();
    if (!uid) return;

    const payload = {
      HotelId: Number(selectedHotel),
      Companyid: company?.id,
      Userid: uid,
      RoomId: roomId,
      RoomType: selectedRoom?.roomType,
      PackageId: Number(pkgId),
      SelectedRoomNumbers: (selectedRooms || []).map(String),
      Qty: qty,
      CheckInDate: checkInDate,
      CheckOutDate: checkOutDate,
      Nights: nightsVal,
      Remark: bookingRemark || '',

      SelectedPrice: {
        AdultCount: Number(selPrice?.adultCount || 0),
        ChildCount: Number(selPrice?.childCount || 0),
        PackageId: Number(pkgId),

        // ✅ FIXED: uses propertyPrice-derived value for OTA, real price for normal
        OriginalPrice: resolvedOriginalPrice,

        DiscountPerRoom: Number(discountPerRoomPerNight || 0),
        FinalPrice: Number(finalPricePerRoomPerNight || 0),

        // ✅ FIXED: total base without GST
        Price: resolvedPriceWithoutDiscount,
      },

      GuestDetails: {
        BillingType: billingType,
        Title: guests[0].title,
        FirstName: guests[0].firstName,
        // Backend DTO expects `string?` for DOB and `int?` for Age. Empty
        // strings deserialise fine for DOB (nullable string) but blow up
        // model binding on Age (int can't parse from ""). Send null when
        // the field is empty so a name+mobile-only booking can save.
        DOB: guests[0].dob ? guests[0].dob : null,
        Age:
          guests[0].age !== '' && guests[0].age != null
            ? Number(guests[0].age)
            : null,
        LastName: guests[0].lastName,
        Email: guests[0].email ?? '',
        MobileNumber: guests[0].mobileNumber,
        Address: guests[0].address,
        City: guests[0].city,
        State: guests[0].state,
        CompanyName: companyForm.companyName,
        GstNo: companyForm.gstNo,
        CompanyAddress: companyForm.address,
        CompanyCity: companyForm.city,
        CompanyState: companyForm.state,
        CompanyMobile: companyForm.mobileNumber,
        CompanyEmail: companyForm.email,
        CardType: guests[0].cardType,
        CardNumber: guests[0].cardNumber,
        ReferenceNo: guests[0].referenceNo,
        Country: guests[0].country,
        IDType: guests[0].idType,
        IDName: guests[0].idName,
        IDNumber: guests[0].idNumber,
        adultCount: Number(adultCount) || 1,
        childCount: Number(childCount) || 0,
        Nationality: guests[0].nationality,
        PassportNumber: guests[0].passportNumber,
        VisaNumber: guests[0].visaNumber,
      },

      OtherGuests: filteredGuests.slice(1).map((g) => ({
        Title: g.title,
        FirstName: g.firstName,
        LastName: g.lastName,
        MobileNumber: g.mobileNumber,
      })),

      Addons: selectedAddons.map((a) => ({
        Name: a.name,
        Qty: Number(a.qty),
        UnitPrice: Number(a.price),
        Price: Number(a.price) * Number(a.qty),
        // This line's GST-inclusive amount (price × qty). Was sending the whole
        // add-on grand total PLUS extra GST on every row, which both inflated
        // the amount and over-counted when there were multiple add-ons.
        AddonFinalAmount: Math.round(Number(a.price || 0) * Number(a.qty || 1)),
      })),

      Discount: {
        Type: discount.type === '%' ? 'Percentage' : 'Fixed',
        Value: Number(discount.value || 0),
      },

      PaidAmount: Number(totalPaid || 0),
      Payments: payments.map((p) => ({
        Mode: p.mode,
        Amount: Number(p.amount || 0),
        ReferenceNo: p.referenceNo,
        CardType: p.cardType,
        CardNumber: p.cardNumber,
      })),

      price: resolvedPriceWithoutDiscount,  // ✅ FIXED
      TotalPrice: basePrice,
      Finalbookingprice: totalPrice,
      PaymentMode: paymentMode,
      finalpriceWithGST: finalAfterCoupon,
      // If ANY agent is selected (the source dropdown OR the OTA modal), force
      // the source to 'Agent' and always send AgentDetails. Otherwise a stale
      // 'WalkIn' source posted a guest-side Book DR and the agent booking
      // wrongly showed a pending amount.
      BookingSource:
        bookingSource === 'Agent' ||
        agentDetails.agentId ||
        agentBooking.agentId
          ? 'Agent'
          : bookingSource,

      AgentDetails:
        bookingSource === 'Agent' ||
        agentDetails.agentId ||
        agentBooking.agentId
          ? {
              AgentId: agentDetails.agentId || agentBooking.agentId,
              ReferenceNo: agentDetails.referenceNo,
              Remark: agentDetails.remark,
            }
          : null,

      AgentBookingType: isOtaBooking ? 'OTA' : 'Direct',
      AgentBooking: isOtaBooking
        ? {
            AgentId: Number(agentBooking.agentId) || agentBooking.agentId,
            AgentName: selectedAgentObj?.name || '',
            BookingPriceWithGST: Number(agentBooking.bookingPriceWithGST || 0),
            PropertyPrice: Number(agentBooking.propertyPrice || 0),
            Commission: Number(agentBooking.commission || 0),
          }
        : null,

      Coupon: selectedCoupon
        ? {
            CouponId: selectedCoupon.id || 0,
            CouponCode: selectedCoupon.coupencode || '',
            CouponType: selectedCoupon.type || null,
            CouponAmount: Number(couponAmount || 0),
          }
        : null,
    };

    console.log('Payload', payload);

    const API_BASE = `${config.API_BASE_URL}`;
    const url = `${API_BASE}/Home/bookPackage`;

    try {
      bookingInFlightRef.current = true; // one click = one booking
      setLoading(true);
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
        body: JSON.stringify(payload),
      });

      const text = await res.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        result = { message: text };
      }

      // Surface the backend's real reason instead of a generic message.
      // A name+mobile-only booking saves fine, but filling extra optional
      // fields can make the server reject the payload — without the actual
      // error text that failure was impossible to diagnose. Log the full
      // response + the payload we sent, and show the server message.
      if (!res.ok || result.message === 'Failed to save booking') {
        // ASP.NET [ApiController] 400 (binding/validation, before the action)
        // puts the failing field(s) in result.errors. Surface them so we see
        // exactly which field rejected the payload.
        const fieldErrors = result?.errors
          ? Object.entries(result.errors)
              .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`)
              .join(' | ')
          : '';
        console.error('[bookPackage] save failed', {
          status: res.status,
          response: result,
          validationErrors: result?.errors,
          sentPayload: payload,
        });
        toast.error(
          fieldErrors
            ? `Booking failed: ${fieldErrors}`
            : result?.message && result.message !== 'Failed to save booking'
              ? `Booking failed: ${result.message}`
              : `Booking failed (server error ${res.status}). Check console.`,
        );
        return;
      }

      const succeeded =
        (result?.message &&
          result.message.toLowerCase().includes('booking successfuly')) ||
        result?.success ||
        result?.bookingId;
      if (succeeded) {
        toast.success('Booking Successful!');
        const newBookingId = result.bookingId || result.id || null;

        // Aadhaar images live only in component state — backend's bookPackage
        // takes JSON, so the files never get persisted there. Fire a second
        // multipart POST per backend's UploadBookingAadhar endpoint to save
        // whichever side(s) the user uploaded. Non-blocking — booking is
        // already saved even if this fails.
        const front = guests?.[0]?.frontImage;
        const back = guests?.[0]?.backImage;
        if (newBookingId && (front || back)) {
          try {
            const fd = new FormData();
            fd.append('BookingId', String(newBookingId));
            if (front) fd.append('FrontImage', front);
            if (back) fd.append('BackImage', back);
            const upRes = await fetch(
              `${config.API_BASE_URL}/Home/UploadBookingAadhar`,
              {
                method: 'POST',
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                },
                body: fd,
              },
            );
            if (!upRes.ok) {
              toast.warn(
                'Booking saved but Aadhaar upload failed. Retry from Bookings → Update.',
              );
            }
          } catch (e) {
            console.error('Aadhaar upload error:', e);
            toast.warn(
              'Booking saved but Aadhaar upload failed. Retry from Bookings → Update.',
            );
          }
        }

        setBookingData({
          ...payload,
          confirmationMessage: result.message || 'Booking created',
          bookingId: newBookingId,
          bookedOn: new Date().toLocaleString('en-GB'),
        });
        setStep(4);
      } else {
        toast.warn(result?.message || 'Unexpected response from server');
      }
    } catch (err) {
      console.error('Network or parsing error in booking:', err);
      toast.error('Network error. Please try again.');
    } finally {
      setLoading(false);
      bookingInFlightRef.current = false;
    }
  }

  const goBack = () => {
    if (step === 1.5) setStep(1);
    else if (step === 2) setStep(1.5);
    else if (step === 3) setStep(2);
  };

  const calculateCouponDiscount = () => {
    if (!selectedCoupon) return 0;

    // Base amount jisme coupon lagega (GST ke baad final)
    const baseAmount = finalAmountWithGST;

    if (selectedCoupon.type === 'PERCENT') {
      return Math.round((baseAmount * selectedCoupon.amount) / 100);
    }

    // Flat ₹ coupon
    return Math.round(selectedCoupon.amount);
  };

  const couponAmount = calculateCouponDiscount();

  // ✅ Final after coupon
  const finalAfterCoupon = Math.max(finalAmountWithGST - couponAmount, 0);

  // ✅ Balance update
  const finalBalanceAfterCoupon = Math.round(finalAfterCoupon - totalPaid);

  /* --------------------------------------------------------------
     RENDER
  -------------------------------------------------------------- */
  return (
    <>
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          flexDirection: 'column',
          gap: 2,
        }}
        open={ocrLoading}>
        <CircularProgress color='inherit' />

        <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
          Scanning Aadhaar...
        </Typography>
      </Backdrop>
      <Container maxWidth='lg' sx={{ mt: 4 }}>
        {/* 🔔 Global Error Alert Box */}
        {globalErrors.length > 0 && (
          <Box
            sx={{
              mb: 3,
              p: 2,
              borderRadius: 2,
              background: '#ffebee',
              border: '1px solid #f44336',
              color: '#b71c1c',
              boxShadow: '0 2px 10px rgba(244,67,54,0.2)',
            }}>
            <Typography variant='h6' fontWeight='bold' mb={1}>
              ⚠️ Please fix the following errors:
            </Typography>
            <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
              {globalErrors.map((err, i) => (
                <li key={i} style={{ fontSize: '0.95rem' }}>
                  {err}
                </li>
              ))}
            </ul>
          </Box>
        )}

        {/* ── Page Hero ── */}
        <Box
          sx={{
            mb: 4,
            p: { xs: 3, sm: 4 },
            borderRadius: 3,
            background: 'linear-gradient(135deg,#0F172A 0%,#1A56DB 100%)',
            color: '#fff',
            position: 'relative',
            overflow: 'hidden',
          }}>
          <Box
            sx={{
              position: 'absolute',
              top: -40,
              right: -40,
              width: 160,
              height: 160,
              borderRadius: '50%',
              background: 'rgba(99, 91, 91, 0.29)',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: -30,
              right: 80,
              width: 100,
              height: 100,
              borderRadius: '50%',
              background: 'rgba(104, 99, 99, 0)',
            }}
          />
          <Typography
            variant='h5'
            fontWeight={700}
            sx={{ letterSpacing: '-0.02em', color: '#fff' }}>
            Manage Inventory
          </Typography>
          <Typography
            variant='body2'
            sx={{ opacity: 0.75, mt: 0.5, color: '#fff' }}>
            New Booking Wizard — {steps.length} steps
          </Typography>
        </Box>
        <Typography variant='h5' textAlign='center' mb={2} fontWeight='bold'>
          Manage Inventory
        </Typography>

        {/* 🆕 OTA Booking active banner */}
        {isOtaBooking && (
          <Box
            sx={{
              mb: 3,
              p: 2,
              borderRadius: 2,
              background: 'linear-gradient(135deg,#fff7ed,#ffedd5)',
              border: '1px solid #fb923c',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 1,
            }}>
            <Box display='flex' alignItems='center' gap={1.5}>
              <StorefrontIcon sx={{ color: '#ea580c' }} />
              <Box>
                <Typography fontWeight={700} color='#9a3412'>
                  Agent / OTA Booking Active
                </Typography>
                <Typography variant='caption' color='#9a3412'>
                  {agents.find(
                    (a) => String(a.id) === String(agentBooking.agentId),
                  )?.name || 'Agent'}{' '}
                  • Booking Price (incl. GST): {Companycurrency}
                  {Number(agentBooking.bookingPriceWithGST).toFixed(2)} •
                  Commission: {Companycurrency}
                  {Number(agentBooking.commission).toFixed(2)}
                </Typography>
              </Box>
            </Box>
            <Button
              size='small'
              color='warning'
              variant='outlined'
              onClick={handleClearAgentBooking}>
              Clear
            </Button>
          </Box>
        )}

        <Stepper
          activeStep={step - 1}
          alternativeLabel
          sx={{
            mb: 4,
            '& .MuiStepLabel-label': { fontWeight: 600, fontSize: '0.8rem' },
            '& .MuiStepIcon-root.Mui-active': { color: '#1A56DB' },
            '& .MuiStepIcon-root.Mui-completed': { color: '#10b981' },
          }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* ==================== STEP 1 ==================== */}
        {step === 1 && (
          <Paper sx={{ p: 3 }}>
            <TextField
              select
              fullWidth
              sx={{ mb: 2 }}
              value={selectedHotel || ''}
              onChange={(e) => setSelectedHotel(Number(e.target.value))}
              error={!!stepErrors.hotel}
              helperText={stepErrors.hotel}>
              {hotels.map((h) => (
                <MenuItem key={h.id} value={h.id}>
                  {h.hotelName}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              type='date'
              fullWidth
              label='Check-in Date'
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
              value={checkInDate}
              onChange={(e) => {
                const newCheckIn = e.target.value;
                setCheckInDate(newCheckIn);

                // 🔥 Auto set checkout = next day
                const nextDay = new Date(newCheckIn);
                nextDay.setDate(nextDay.getDate() + 1);
                setCheckOutDate(nextDay.toISOString().split('T')[0]);
              }}
            />

            <TextField
              type='date'
              fullWidth
              label='Check-out Date'
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
              value={checkOutDate}
              onChange={(e) => setCheckOutDate(e.target.value)}
              inputProps={{
                min: checkInDate
                  ? new Date(new Date(checkInDate).getTime() + 86400000)
                      .toISOString()
                      .split('T')[0]
                  : '',
              }}
              error={!!stepErrors.checkOut}
              helperText={stepErrors.checkOut}
            />

            <Button variant='contained' fullWidth onClick={fetchRooms}>
              Fetch Rooms
            </Button>

            {loading && (
              <CircularProgress sx={{ mt: 2, display: 'block', mx: 'auto' }} />
            )}
            {rooms.length > 0 && (
              <TableContainer
                component={Paper}
                elevation={0}
                sx={{ mt: 3, borderRadius: 2, border: '1px solid #E2E8F0' }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ background: '#F8FAFF' }}>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          color: '#64748B',
                          fontSize: '0.75rem',
                          textTransform: 'uppercase',
                          letterSpacing: '0.06em',
                        }}>
                        Room Type
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          color: '#64748B',
                          fontSize: '0.75rem',
                          textTransform: 'uppercase',
                          letterSpacing: '0.06em',
                        }}>
                        Available
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          color: '#64748B',
                          fontSize: '0.75rem',
                          textTransform: 'uppercase',
                          letterSpacing: '0.06em',
                        }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rooms.map((r) => (
                      <TableRow key={r.roomId}>
                        <TableCell>{r.roomType}</TableCell>
                        <TableCell>{r.availableQty}</TableCell>
                        <TableCell>
                          <Button
                            variant='outlined'
                            onClick={() => selectRoom(r)}>
                            Select
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        )}

        {/* ==================== STEP 1.5 ==================== */}
        {step === 1.5 && (
          <Paper
            elevation={0}
            sx={{
              p: 3,
              borderRadius: 3,
              border: '1px solid #E2E8F0',
              background: '#fff',
            }}>
            <Box display='flex' alignItems='center' mb={3}>
              <IconButton
                onClick={goBack}
                sx={{
                  background: '#F8FAFF',
                  border: '1px solid #E2E8F0',
                  mr: 1.5,
                }}>
                <ArrowBack sx={{ fontSize: 18 }} />
              </IconButton>
              <Box>
                <Typography variant='h6' fontWeight={700} color='#0F172A'>
                  Select Rooms
                </Typography>
                <Typography variant='body2' color='#64748B'>
                  {selectedRoom?.roomType}
                </Typography>
              </Box>
            </Box>
            <Grid container spacing={1.5}>
              {roomAvailability.map((room) => {
                const isOccupied = room.status !== 'Available';
                const isSelected = selectedRooms.includes(room.roomnumber);
                // Guest name/mobile come straight from the availability SP for
                // occupied rooms (same source that marks the room red).
                const hasGuest =
                  isOccupied && (room.guestName || room.mobile);
                const fmtD = (d) =>
                  d
                    ? new Date(d).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      })
                    : '';
                const tip = hasGuest ? (
                  <Box sx={{ p: 0.5 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 13 }}>
                      {room.guestName?.trim() || 'Guest'}
                    </Typography>
                    {room.mobile && (
                      <Typography sx={{ fontSize: 12 }}>
                        📞 {room.mobile}
                      </Typography>
                    )}
                    {(room.checkIn || room.checkOut) && (
                      <Typography sx={{ fontSize: 11, opacity: 0.85, mt: 0.3 }}>
                        {fmtD(room.checkIn)} → {fmtD(room.checkOut)}
                      </Typography>
                    )}
                  </Box>
                ) : (
                  ''
                );
                return (
                  <Grid item xs={4} sm={3} md={2} key={room.roomnumber}>
                    <Tooltip title={tip} arrow placement='top'>
                    <Box
                      sx={{
                        bgcolor: isOccupied
                          ? '#dc2626'
                          : isSelected
                            ? '#1A56DB'
                            : '#16a34a',
                        color: '#ffffff',
                        p: 1.5,
                        borderRadius: 2,
                        textAlign: 'center',
                        cursor: isOccupied ? 'not-allowed' : 'pointer',
                        // Full opacity — the old 0.55 fade made occupied tiles a
                        // washed-out pink with an unreadable white number. Red bg
                        // alone already signals "occupied" (per the legend).
                        opacity: 1,
                        border: isOccupied ? '1px solid #b91c1c' : 'none',
                        textShadow: '0 1px 2px rgba(0,0,0,0.35)',
                        fontWeight: 700,
                        fontSize: '0.9rem',
                        boxShadow: isSelected
                          ? '0 4px 12px rgba(26,86,219,0.3)'
                          : isOccupied
                            ? 'none'
                            : '0 2px 8px rgba(16,185,129,0.2)',
                        transition: 'all 0.18s',
                        '&:hover': !isOccupied
                          ? {
                              filter: 'brightness(1.08)',
                              transform: 'scale(1.04)',
                            }
                          : {},
                      }}
                      onClick={() => {
                        if (isOccupied) return;
                        setSelectedRooms((prev) =>
                          prev.includes(room.roomnumber)
                            ? prev.filter((x) => x !== room.roomnumber)
                            : [...prev, room.roomnumber],
                        );
                      }}>
                      {roomNameMap[room.roomnumber] || room.roomnumber}
                    </Box>
                    </Tooltip>
                  </Grid>
                );
              })}
            </Grid>

            {/* Selected rooms list with a remove (✕) on each chip, so a
                mistakenly picked room can be dropped instantly. Removing updates
                selectedRooms — the same state that drives qty, totals, taxes and
                the room tile colours — so everything recalculates automatically. */}
            {selectedRooms.length > 0 && (
              <Box
                mt={2}
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1,
                  alignItems: 'center',
                  p: 1.5,
                  borderRadius: 2,
                  bgcolor: '#F8FAFF',
                  border: '1px solid #E2E8F0',
                }}>
                <Typography
                  variant='caption'
                  sx={{ fontWeight: 700, color: '#1A56DB', mr: 0.5 }}>
                  Selected ({selectedRooms.length}):
                </Typography>
                {selectedRooms.map((rn) => (
                  <Chip
                    key={rn}
                    label={roomNameMap[rn] || rn}
                    onDelete={() =>
                      setSelectedRooms((prev) => prev.filter((x) => x !== rn))
                    }
                    size='small'
                    sx={{
                      bgcolor: '#1A56DB',
                      color: '#fff',
                      fontWeight: 600,
                      '& .MuiChip-deleteIcon': {
                        color: 'rgba(255,255,255,0.85)',
                        '&:hover': { color: '#fff' },
                      },
                    }}
                  />
                ))}
              </Box>
            )}

            <Box
              mt={3}
              display='flex'
              alignItems='center'
              justifyContent='space-between'>
              <Box display='flex' gap={1.5}>
                {[
                  ['#10b981', 'Available'],
                  ['#1A56DB', 'Selected'],
                  ['#f43f5e', 'Occupied'],
                ].map(([c, l]) => (
                  <Box key={l} display='flex' alignItems='center' gap={0.5}>
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        bgcolor: c,
                      }}
                    />
                    <Typography variant='caption' color='#64748B'>
                      {l}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <Button
                variant='contained'
                onClick={fetchPackages}
                disabled={selectedRooms.length === 0}
                sx={{
                  background: 'linear-gradient(135deg,#1A56DB,#3b82f6)',
                  boxShadow: '0 4px 12px rgba(26,86,219,0.3)',
                  textTransform: 'none',
                  fontWeight: 600,
                }}>
                Continue ({selectedRooms.length} selected)
              </Button>
            </Box>
          </Paper>
        )}

        {/* ==================== STEP 2 ==================== */}
        {step === 2 && (
          <Paper
            sx={{
              py: 5,
              px: { xs: 2, sm: 4, md: 6 },
              minHeight: '88vh',
              borderRadius: 3,
              backgroundColor: '#f7f9fc',
              boxShadow: '0 4px 25px rgba(0,0,0,0.05)',
            }}>
            {/* Header */}
            <Box
              display='flex'
              alignItems='center'
              justifyContent='space-between'
              mb={4}
              flexWrap='wrap'
              gap={2}>
              {/* Left Side */}
              <Box display='flex' alignItems='center'>
                <IconButton
                  onClick={goBack}
                  sx={{
                    background: '#fff',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    mr: 2,
                    '&:hover': { background: '#f0f4f8' },
                  }}>
                  <ArrowBack />
                </IconButton>

                <Box>
                  <Typography
                    variant='h5'
                    fontWeight='700'
                    sx={{
                      color: '#1c2a4a',
                      letterSpacing: '0.5px',
                    }}>
                    Select Your Package
                  </Typography>

                  <Typography
                    variant='body2'
                    color='text.secondary'
                    sx={{ fontSize: '0.9rem' }}>
                    Available experiences at{' '}
                    {selectedHotel?.hotelName || 'selected hotel'}
                  </Typography>
                </Box>
              </Box>

              {/* Right Side Buttons */}
              <Box display='flex' gap={2} flexWrap='wrap'>
                {/* 🆕 THROUGH AGENT / OTA BUTTON */}
                <Button
                  variant='contained'
                  startIcon={<StorefrontIcon />}
                  onClick={() => setThroughAgentOpen(true)}
                  sx={{
                    borderRadius: '12px',
                    px: 3,
                    fontWeight: 700,
                    textTransform: 'none',
                    background:
                      'linear-gradient(135deg,#ea580c 0%,#f97316 100%)',
                    boxShadow: '0 4px 14px rgba(234,88,12,0.35)',
                    '&:hover': {
                      background:
                        'linear-gradient(135deg,#c2410c 0%,#ea580c 100%)',
                    },
                  }}>
                  Through Agent
                </Button>

                <Button
                  variant='outlined'
                  color='secondary'
                  onClick={() => {
                    window.location.href = '/admin/managepackage';
                  }}
                  sx={{
                    borderRadius: '12px',
                    px: 3,
                    fontWeight: 600,
                    textTransform: 'none',
                  }}>
                  + Add Package
                </Button>

                <Button
                  variant='outlined'
                  color='secondary'
                  onClick={() => {
                    window.location.href = '/admin/Addonm';
                  }}
                  sx={{
                    borderRadius: '12px',
                    px: 3,
                    fontWeight: 600,
                    textTransform: 'none',
                  }}>
                  + Add Addons
                </Button>
              </Box>
            </Box>

            {/* 🆕 OTA Active note inside step 2 */}
            {isOtaBooking && (
              <Box
                sx={{
                  mb: 3,
                  p: 1.5,
                  borderRadius: 2,
                  background: '#fff7ed',
                  border: '1px dashed #fb923c',
                }}>
                <Typography variant='body2' color='#9a3412' fontWeight={600}>
                  ℹ️ Agent booking applied. Final amount will use Booking Price
                  (incl. GST) = {Companycurrency}
                  {Number(agentBooking.bookingPriceWithGST).toFixed(2)}. Select a
                  package & price to continue, then complete guest details.
                </Typography>
              </Box>
            )}

            {/* Packages Grid */}
            <Grid container spacing={3} justifyContent='center'>
              {packages.length > 0 ? (
                packages.map((pkg, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3.5} key={pkg.packageId}>
                    <motion.div
                      initial={{ opacity: 0, y: 25 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4, delay: index * 0.08 }}>
                      <Box
                        sx={{
                          borderRadius: 2,
                          backgroundColor: '#ffffff',
                          border: '1px solid #e2e8f0',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
                          transition: 'all 0.25s ease',
                          p: 2.5,
                          height: '100%',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                            borderColor: '#d0deec',
                          },
                        }}>
                        {/* Package Title */}
                        <Typography
                          variant='h6'
                          fontWeight='700'
                          sx={{
                            color: '#1c2a4a',
                            mb: 1,
                            fontSize: '1.05rem',
                          }}>
                          {pkg.packageName}
                        </Typography>

                        <Typography
                          variant='body2'
                          sx={{
                            color: '#5c6b80',
                            display: 'flex',
                            alignItems: 'center',
                            mb: 0.5,
                          }}>
                          🏨 {pkg.hotelName}
                        </Typography>
                        <Typography
                          variant='body2'
                          sx={{
                            color: '#5c6b80',
                            display: 'flex',
                            alignItems: 'center',
                            mb: 0.5,
                          }}>
                          🛏 {pkg.roomType}
                        </Typography>
                        <Typography
                          variant='body2'
                          sx={{
                            color: '#6b7b93',
                            fontStyle: 'italic',
                            mb: 2,
                          }}>
                          {pkg.description}
                        </Typography>

                        {/* Price Section */}
                        {pkg.lowestPrice != null ? (
                          <Box
                            sx={{
                              p: 1.5,
                              borderRadius: 1.5,
                              backgroundColor: '#f5f8fc',
                              border: '1px solid #dbe5f2',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              mb: 1.5,
                            }}>
                            <Typography
                              variant='h6'
                              fontWeight='700'
                              sx={{
                                color: '#004b8d',
                                fontSize: '1.05rem',
                              }}>
                              {Companycurrency}{' '}
                              {pkg.lowestPrice.toLocaleString('en-IN')} /-
                            </Typography>
                            <Typography
                              variant='caption'
                              sx={{ color: '#6c7b90', fontWeight: 500 }}>
                              Starts From
                            </Typography>
                          </Box>
                        ) : (
                          <Typography
                            variant='body2'
                            color='text.secondary'
                            sx={{ fontStyle: 'italic', mb: 1 }}>
                            Price not available
                          </Typography>
                        )}

                        {/* View Pricing Button */}
                        <Button
                          variant='contained'
                          fullWidth
                          sx={{
                            py: 1.1,
                            mt: 'auto',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.95rem',
                            borderRadius: 2,
                            backgroundColor: '#004b8d',
                            boxShadow: '0 3px 8px rgba(0,75,141,0.25)',
                            '&:hover': {
                              backgroundColor: '#005eb8',
                              boxShadow: '0 4px 14px rgba(0,75,141,0.35)',
                            },
                          }}
                          onClick={() => {
                            setSelectedPkg(pkg);
                            setPriceOptions(pkg.memberWisePrices || []);
                            setPriceModalOpen(true);
                          }}>
                          View Pricing Options
                        </Button>
                      </Box>
                    </motion.div>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Typography
                    align='center'
                    color='text.secondary'
                    fontSize='1.05rem'
                    sx={{ mt: 5 }}>
                    No packages found
                  </Typography>
                </Grid>
              )}
            </Grid>

            {/* Price Modal */}
            <Dialog
              open={priceModalOpen}
              onClose={() => setPriceModalOpen(false)}
              maxWidth='xs'
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  backgroundColor: '#fff',
                  boxShadow: '0 10px 35px rgba(0,0,0,0.1)',
                },
              }}>
              <DialogTitle
                sx={{
                  fontWeight: 700,
                  color: '#1c2a4a',
                  textAlign: 'center',
                  pb: 1,
                }}>
                Select Package Price
              </DialogTitle>

              <DialogContent>
                {priceOptions.map((p) => (
                  <motion.div key={p.id} whileHover={{ scale: 1.02 }}>
                    <Button
                      fullWidth
                      variant='contained'
                      sx={{
                        my: 1,
                        py: 1.1,
                        borderRadius: 2,
                        fontWeight: 600,
                        fontSize: '0.95rem',
                        textTransform: 'none',
                        backgroundColor: '#004b8d',
                        boxShadow: '0 3px 10px rgba(0,75,141,0.25)',
                        '&:hover': {
                          backgroundColor: '#005eb8',
                          boxShadow: '0 4px 14px rgba(0,75,141,0.35)',
                        },
                      }}
                      onClick={() => {
                        setSelectedPrice(p);
                        setPriceModalOpen(false);
                        setStep(3);
                      }}>
                      {p.memberType} — {Companycurrency}
                      {p.price.toLocaleString('en-IN')}
                    </Button>
                  </motion.div>
                ))}
              </DialogContent>
            </Dialog>

            {/* ==========================================================
                🆕 THROUGH AGENT / OTA DIALOG
            ========================================================== */}
            <Dialog
              open={throughAgentOpen}
              onClose={() => setThroughAgentOpen(false)}
              maxWidth='sm'
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  overflow: 'hidden',
                },
              }}>
              <Box
                sx={{
                  background:
                    'linear-gradient(135deg,#ea580c 0%,#f97316 100%)',
                  color: '#fff',
                  px: 3,
                  py: 2.2,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.2,
                }}>
                <StorefrontIcon />
                <Box>
                  <Typography fontWeight={700} variant='h6'>
                    Agent / OTA Booking
                  </Typography>
                  <Typography variant='caption' sx={{ opacity: 0.85 }}>
                    MakeMyTrip • Goibibo • Booking.com • Agoda etc.
                  </Typography>
                </Box>
              </Box>

              <DialogContent sx={{ pt: 3 }}>
                <Grid container spacing={2.5} sx={{ mt: 0 }}>
                  {/* Agent Dropdown */}
                  <Grid item xs={12}>
                    <TextField
                      select
                      label='Select Agent / OTA *'
                      fullWidth
                      size='small'
                      value={agentBooking.agentId}
                      onChange={(e) =>
                        handleAgentBookingChange('agentId', e.target.value)
                      }>
                      {agents.length === 0 ? (
                        <MenuItem disabled value=''>
                          No agents found
                        </MenuItem>
                      ) : (
                        agents.map((a) => (
                          <MenuItem key={a.id} value={a.id}>
                            {a.name}
                          </MenuItem>
                        ))
                      )}
                    </TextField>
                  </Grid>

                  {/* Booking Price With GST */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Booking Price (incl. GST) *'
                      type='number'
                      fullWidth
                      size='small'
                      value={agentBooking.bookingPriceWithGST}
                      onChange={(e) =>
                        handleAgentBookingChange(
                          'bookingPriceWithGST',
                          e.target.value,
                        )
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            {Companycurrency}
                          </InputAdornment>
                        ),
                      }}
                      helperText='Amount OTA charged customer (final, incl. GST)'
                    />
                  </Grid>

                  {/* Property Price */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Property Price *'
                      type='number'
                      fullWidth
                      size='small'
                      value={agentBooking.propertyPrice}
                      onChange={(e) =>
                        handleAgentBookingChange(
                          'propertyPrice',
                          e.target.value,
                        )
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            {Companycurrency}
                          </InputAdornment>
                        ),
                      }}
                      helperText='Amount property actually receives'
                    />
                  </Grid>

                  {/* Auto Commission */}
                  <Grid item xs={12}>
                    <TextField
                      label='Commission (Auto)'
                      fullWidth
                      size='small'
                      value={agentBooking.commission}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position='start'>
                            {Companycurrency}
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiInputBase-input': {
                          fontWeight: 700,
                          color: '#16a34a',
                        },
                      }}
                      helperText='Commission = Booking Price − Property Price'
                    />
                  </Grid>

                  {/* Live preview chip */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        background: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        gap: 1,
                        flexWrap: 'wrap',
                      }}>
                      <Chip
                        label={`Booking: ${Companycurrency}${Number(
                          agentBooking.bookingPriceWithGST || 0,
                        ).toFixed(2)}`}
                        color='primary'
                        variant='outlined'
                      />
                      <Chip
                        label={`Property: ${Companycurrency}${Number(
                          agentBooking.propertyPrice || 0,
                        ).toFixed(2)}`}
                        variant='outlined'
                      />
                      <Chip
                        label={`Commission: ${Companycurrency}${Number(
                          agentBooking.commission || 0,
                        ).toFixed(2)}`}
                        color='success'
                      />
                    </Box>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions sx={{ px: 3, pb: 2.5 }}>
                <Button
                  onClick={() => setThroughAgentOpen(false)}
                  color='inherit'>
                  Cancel
                </Button>
                <Button
                  variant='contained'
                  onClick={handleApplyAgentBooking}
                  sx={{
                    background:
                      'linear-gradient(135deg,#ea580c 0%,#f97316 100%)',
                    textTransform: 'none',
                    fontWeight: 700,
                    px: 3,
                  }}>
                  Apply & Continue
                </Button>
              </DialogActions>
            </Dialog>
          </Paper>
        )}

        {/* ==================== STEP 3 ==================== */}
        {step === 3 && (
          <Paper sx={{ p: 3 }}>
            <Box display='flex' alignItems='center' mb={3}>
              <IconButton onClick={goBack}>
                <ArrowBack />
              </IconButton>
              <Typography variant='h6' ml={1}>
                Guest Details & Payment
              </Typography>
            </Box>

            {/* 🆕 OTA booking summary chip inside step 3 */}
            {isOtaBooking && (
              <Box
                sx={{
                  mb: 2,
                  p: 1.5,
                  borderRadius: 2,
                  background: '#fff7ed',
                  border: '1px solid #fb923c',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  flexWrap: 'wrap',
                }}>
                <StorefrontIcon sx={{ color: '#ea580c' }} fontSize='small' />
                <Typography variant='body2' color='#9a3412' fontWeight={600}>
                  OTA:{' '}
                  {agents.find(
                    (a) => String(a.id) === String(agentBooking.agentId),
                  )?.name || 'Agent'}{' '}
                  | Booking (incl. GST): {Companycurrency}
                  {Number(agentBooking.bookingPriceWithGST).toFixed(2)} |
                  Property: {Companycurrency}
                  {Number(agentBooking.propertyPrice).toFixed(2)} | Commission:{' '}
                  {Companycurrency}
                  {Number(agentBooking.commission).toFixed(2)}
                </Typography>
              </Box>
            )}

            {/* ---------- BOOKING SUMMARY ---------- */}
            <Paper variant='outlined' sx={{ p: 2, mb: 3, bgcolor: '#f9f9f9' }}>
              <Typography variant='subtitle1' fontWeight='bold' gutterBottom>
                Booking Summary
              </Typography>

              <Box
                sx={{
                  mt: 4,
                  p: 4,
                  borderRadius: 5,
                  background: 'linear-gradient(180deg, #ffffff, #f7faff)',
                  boxShadow: '0 4px 25px rgba(0,0,0,0.08)',
                  border: '1px solid #e9eef5',
                }}>
                {/* Header */}
                <Typography
                  variant='h5'
                  sx={{
                    fontWeight: 700,
                    mb: 3,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#007bff',
                    gap: 1,
                  }}>
                  📘 Booking Summary
                </Typography>

                <Grid
                  container
                  spacing={3}
                  sx={{
                    borderRadius: 3,
                    px: 2,
                  }}>
                  {/* LEFT SIDE */}
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      borderRight: { md: '2px solid #eef2f7' },
                      pr: { md: 4 },
                    }}>
                    <Typography
                      variant='subtitle1'
                      sx={{
                        fontWeight: 'bold',
                        color: '#ff6f00',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        mb: 1.5,
                      }}>
                      🏠 Hotel & Stay Details
                    </Typography>

                    <Table size='small'>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', py: 1 }}>
                            🏨 Hotel
                          </TableCell>
                          <TableCell sx={{ py: 1 }}>
                            {hotels.find((h) => h.id == selectedHotel)
                              ?.hotelName || '-'}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', py: 1 }}>
                            🛏️ Room Type
                          </TableCell>
                          <TableCell sx={{ py: 1 }}>
                            {selectedRoom?.roomType || '-'}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', py: 1 }}>
                            🧾 Rooms Selected
                          </TableCell>
                          <TableCell sx={{ py: 1 }}>
                            {selectedRooms.length > 0
                              ? `${selectedRooms.join(', ')} (${qty} room${qty > 1 ? 's' : ''})`
                              : '-'}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', py: 1 }}>
                            📅 Check-in
                          </TableCell>
                          <TableCell sx={{ py: 1 }}>
                            {checkInDate || '-'}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', py: 1 }}>
                            📅 Check-out
                          </TableCell>
                          <TableCell sx={{ py: 1 }}>
                            {checkOutDate || '-'}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', py: 1 }}>
                            🌙 Nights
                          </TableCell>
                          <TableCell sx={{ py: 1 }}>
                            {nights} {nights === 1 ? 'night' : 'nights'}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Grid>

                  {/* RIGHT SIDE */}
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      pl: { md: 4 },
                    }}>
                    <Typography
                      variant='subtitle1'
                      sx={{
                        fontWeight: 'bold',
                        color: '#ab47bc',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        mb: 1.5,
                      }}>
                      🔥 Pricing Summary
                    </Typography>

                    <Table size='small'>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', py: 1 }}>
                            🟩 Rate / Night / Room
                          </TableCell>
                          <TableCell sx={{ py: 1, textAlign: 'right' }}>
                            {Companycurrency}
                            {roomPricePerNight.toFixed(2)}
                          </TableCell>
                        </TableRow>

                        {discountPerRoomPerNight > 0 && (
                          <TableRow>
                            <TableCell
                              sx={{
                                py: 1,
                                pl: 4,
                                color: 'error.main',
                                fontWeight: 500,
                              }}>
                              🔻 Discount (
                              {discount.type === '%'
                                ? `${discount.value}%`
                                : `${Companycurrency}${discount.value}`}
                              )
                            </TableCell>
                            <TableCell
                              sx={{
                                py: 1,
                                textAlign: 'right',
                                color: 'error.main',
                              }}>
                              - {Companycurrency}
                              {discountPerRoomPerNight.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        )}

                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: 'bold',
                              py: 1,
                              color: 'success.main',
                            }}>
                            ✅ Final Rate / Room / Night
                          </TableCell>
                          <TableCell
                            sx={{
                              py: 1,
                              textAlign: 'right',
                              color: 'success.main',
                              fontWeight: 600,
                            }}>
                            {Companycurrency}
                            {finalPricePerRoomPerNight.toFixed(2)}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', py: 1 }}>
                            📦 Base Price ({qty} × {nights})
                          </TableCell>
                          <TableCell sx={{ py: 1, textAlign: 'right' }}>
                            {Companycurrency}
                            {basePrice.toFixed(2)}
                          </TableCell>
                        </TableRow>

                        {addonTotal > 0 && (
                          <>
                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 'bold',
                                  py: 1,
                                  color: '#ff9800',
                                  background: 'rgba(255,215,0,0.08)',
                                }}>
                                ✨ Add-ons Total
                              </TableCell>
                              <TableCell
                                sx={{
                                  py: 1,
                                  textAlign: 'right',
                                  background: 'rgba(255,215,0,0.08)',
                                }}>
                                {Companycurrency}
                                {addonTotal.toFixed(2)}
                              </TableCell>
                            </TableRow>

                            {selectedAddons
                              .filter(
                                (a) =>
                                  (a.name || a.Name) && (a.price || a.Price),
                              )
                              .map((a, i) => (
                                <TableRow key={i}>
                                  <TableCell
                                    sx={{
                                      py: 0.8,
                                      pl: 4,
                                      fontSize: '0.875rem',
                                      color: 'text.secondary',
                                    }}>
                                    {a.name || a.Name}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      py: 0.8,
                                      textAlign: 'right',
                                      fontSize: '0.875rem',
                                      color: 'text.secondary',
                                    }}>
                                    {Companycurrency}
                                    {Number(a.price || a.Price).toFixed(2)}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </>
                        )}

                        <TableRow>
                          <TableCell colSpan={2} sx={{ py: 0 }}>
                            <Divider sx={{ my: 1.5 }} />
                          </TableCell>
                        </TableRow>
                        {/* GST rows only when the company charges GST (India).
                            VAT / No-Tax companies must not see GST lines at all. */}
                        {isGstApplicable() && (
                        <>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: 'bold',
                              py: 1.3,
                              color: '#607d8b',
                            }}>
                            Total GST Amount
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 'bold',
                              textAlign: 'right',
                              color: '#007bff',
                            }}>
                            {Companycurrency}
                            {totalGST?.toFixed(2)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Addon GST ({addonGstRate}%)</TableCell>
                          <TableCell align='right'>
                            {Companycurrency}
                            {addonGST.toFixed(2)}
                          </TableCell>
                        </TableRow>
                        </>
                        )}

                        {/* 🆕 Commission row (info only, OTA bookings) */}
                        {isOtaBooking && (
                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: 'bold',
                                py: 1,
                                color: '#16a34a',
                              }}>
                              🤝 Agent Commission
                            </TableCell>
                            <TableCell
                              sx={{
                                py: 1,
                                textAlign: 'right',
                                color: '#16a34a',
                                fontWeight: 600,
                              }}>
                              {Companycurrency}
                              {Number(agentBooking.commission).toFixed(2)}
                            </TableCell>
                          </TableRow>
                        )}

                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: 'bold',
                              fontSize: '1.05rem',
                              py: 1.3,
                              color: '#607d8b',
                            }}>
                            💳 Total Amount
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 'bold',
                              fontSize: '1.1rem',
                              textAlign: 'right',
                              color: '#007bff',
                            }}>
                            {Companycurrency}
                            {finalAfterCoupon.toFixed(2)}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: 'bold',
                              py: 1,
                              color: '#4caf50',
                            }}>
                            📗 Paid Amount
                          </TableCell>
                          <TableCell sx={{ py: 1, textAlign: 'right' }}>
                            {Companycurrency}
                            {Number(totalPaid || 0).toFixed(2)}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: 'bold',
                              py: 1,
                              color: '#f44336',
                            }}>
                            📕 Balance Due
                          </TableCell>
                          <TableCell
                            sx={{
                              py: 1,
                              textAlign: 'right',
                              fontWeight: 'bold',
                              color:
                                finalBalance > 0
                                  ? 'error.main'
                                  : 'success.main',
                            }}>
                            {Companycurrency}
                            {finalBalanceAfterCoupon.toFixed(2)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Grid>
                </Grid>
              </Box>
            </Paper>

            <Box
              sx={{
                mt: 4,
                p: 4,
                borderRadius: 4,
                background: 'linear-gradient(180deg, #ffffff, #f6f9ff)',
                boxShadow: '0 4px 25px rgba(0,0,0,0.08)',
                border: '1px solid #e0e6f1',
              }}>
              {/* ---------- BILLING TYPE ---------- */}
              <Typography
                variant='h6'
                fontWeight='bold'
                sx={{
                  mb: 2,
                  color: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}>
                🧾 Billing Type
              </Typography>
              <RadioGroup
                row
                value={billingType}
                onChange={(e) => {
                  const val = e.target.value;
                  setBillingType(val);
                  setCompanyFormOpen(val === 'Company');
                }}
                sx={{ mb: 3 }}>
                <FormControlLabel
                  value='Customer'
                  control={<Radio />}
                  label='Customer'
                />
                <FormControlLabel
                  value='Company'
                  control={<Radio />}
                  label='Company'
                />
              </RadioGroup>

              <Divider sx={{ my: 3 }} />

              <Card
                sx={{
                  mb: 5,
                  borderRadius: 4,
                  overflow: 'hidden',
                  background: 'white',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                  border: '1px solid #e0e7ff',
                }}>
                {/* HEADER */}
                <Box
                  sx={{
                    background:
                      'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                    color: 'white',
                    py: 2,
                    px: 3,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    flexWrap: 'wrap',
                  }}>
                  <Typography variant='h6' fontWeight='bold'>
                    👤 Guest Details ({adultCount} Adult
                    {adultCount > 1 ? 's' : ''})
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      size='small'
                      variant='contained'
                      onClick={() => openBookingFormPrint(true)}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.18)',
                        color: '#fff',
                        textTransform: 'none',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.28)' },
                      }}>
                      Print Filled
                    </Button>
                    <Button
                      size='small'
                      variant='contained'
                      onClick={() => openBookingFormPrint(false)}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.18)',
                        color: '#fff',
                        textTransform: 'none',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.28)' },
                      }}>
                      Print Blank
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ p: 3 }}>
                  {/* ADULT / CHILD */}
                  <Grid container spacing={2} mb={3}>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      {guests[0]?.nationality === 'Native' && (
                        <>
                          {/* FRONT IMAGE */}
                          <Grid item xs={12} md={6}>
                            <Button
                              variant='outlined'
                              component='label'
                              fullWidth
                              startIcon={<UploadIcon />}>
                              Upload Front Aadhaar
                              <input
                                hidden
                                type='file'
                                accept='image/*'
                                onChange={(e) => {
                                  const file = e.target.files[0];

                                  setFrontImage(file);

                                  if (file && backImage) {
                                    handleAadharOCR(file, backImage);
                                  }
                                }}
                              />
                            </Button>

                            {frontImage && (
                              <Typography variant='body2' sx={{ mt: 1 }}>
                                {frontImage.name}
                              </Typography>
                            )}
                          </Grid>

                          {/* BACK IMAGE */}
                          <Grid item xs={12} md={6}>
                            <Button
                              variant='outlined'
                              component='label'
                              fullWidth
                              startIcon={<UploadIcon />}>
                              Upload Back Aadhaar
                              <input
                                hidden
                                type='file'
                                accept='image/*'
                                onChange={(e) => {
                                  const file = e.target.files[0];

                                  setBackImage(file);

                                  if (frontImage && file) {
                                    handleAadharOCR(frontImage, file);
                                  }
                                }}
                              />
                            </Button>

                            {backImage && (
                              <Typography variant='body2' sx={{ mt: 1 }}>
                                {backImage.name}
                              </Typography>
                            )}
                          </Grid>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        type='number'
                        size='small'
                        label='Number of Adults'
                        value={adultCount}
                        inputProps={{ min: 1 }}
                        onChange={(e) => {
                          const count = Math.max(
                            1,
                            Number(e.target.value) || 1,
                          );

                          setAdultCount(count);

                          setGuests((prev) => {
                            const updated = [...prev];

                            while (updated.length < count) {
                              updated.push({
                                title: 'Mr',
                                dob: '',
                                age: '',
                                nationality: 'Native',
                                country: 'India',
                                firstName: '',
                                lastName: '',
                                email: '',
                                mobileNumber: '',
                                address: '',
                                city: '',
                                state: '',
                                idType: 'Aadhar Card',
                                passportNumber: '',
                                visaNumber: '',
                                idName: '',
                                idNumber: '',
                                idPhotos: [],
                              });
                            }

                            return updated.slice(0, count);
                          });
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label='Number of Children'
                        type='number'
                        size='small'
                        fullWidth
                        value={childCount}
                        onChange={(e) =>
                          setChildCount(
                            Math.max(0, Number(e.target.value) || 0),
                          )
                        }
                      />
                    </Grid>
                  </Grid>

                  {/* GUEST LIST */}
                  {guests.map((guest, index) => {
                    const isPrimary = index === 0;
                    const countryCode = allCountries.find(
                      (c) => c.name === guest.country,
                    )?.isoCode;

                    const states = State.getStatesOfCountry(countryCode || '');
                    return (
                      <Box
                        key={index}
                        sx={{
                          mb: 3,
                          p: 2.5,
                          borderRadius: 3,
                          border: isPrimary
                            ? '2px solid #6366f1'
                            : '1px solid #e5e7eb',
                          background: isPrimary ? '#eef2ff' : '#fafafa',
                          position: 'relative',
                        }}>
                        {isPrimary && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: -10,
                              left: 16,
                              background: '#6366f1',
                              color: 'white',
                              px: 1.5,
                              py: 0.3,
                              borderRadius: 2,
                              fontSize: '0.75rem',
                              fontWeight: 'bold',
                            }}>
                            Primary Guest
                          </Box>
                        )}

                        <Typography fontWeight='bold' mb={2}>
                          Guest {index + 1}
                        </Typography>
                        <Grid container spacing={2} mb={2}>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              select
                              label='Nationality'
                              size='small'
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              value={guest.nationality || 'Native'} // 👈 yahi change
                              onChange={(e) => {
                                const g = [...guests];
                                g[index].nationality = e.target.value;
                                g[index].idNumber = '';
                                g[index].passportNumber = '';
                                g[index].visaNumber = '';
                                setGuests(g);
                              }}>
                              <MenuItem value='Native'>Native</MenuItem>
                              <MenuItem value='Foreigner'>Foreigner</MenuItem>
                            </TextField>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} mb={2}>
                          {guest.nationality === 'Native' && (
                            <Grid item xs={6}>
                              <TextField
                                select
                                label='ID Type'
                                size='small'
                                fullWidth
                                value={guest.idType}
                                onChange={(e) => {
                                  const g = [...guests];
                                  g[index].idType = e.target.value;
                                  setGuests(g);
                                }}>
                                <MenuItem selected value='Aadhar Card'>
                                  Aadhar Card
                                </MenuItem>

                                <MenuItem value='Driving Licence'>
                                  Driving Licence
                                </MenuItem>

                                <MenuItem value='Votter Id'>Votter Id</MenuItem>
                                <MenuItem value='PassPort'>PassPort</MenuItem>
                              </TextField>
                            </Grid>
                          )}

                          {guest.nationality !== 'Native' && (
                            <Grid item xs={6}>
                              <TextField
                                select
                                label='ID Type'
                                size='small'
                                fullWidth
                                value={guest.idType}
                                onChange={(e) => {
                                  const g = [...guests];
                                  g[index].idType = e.target.value;
                                  setGuests(g);
                                }}>
                                <MenuItem value='Passport'>Passport</MenuItem>
                              </TextField>
                            </Grid>
                          )}

                          <Grid item xs={6}>
                            <TextField
                              label='ID Number'
                              size='small'
                              fullWidth
                              value={guest.idNumber}
                              onChange={(e) => {
                                const g = [...guests];
                                g[index].idNumber = e.target.value;
                                setGuests(g);
                              }}
                            />
                          </Grid>

                          <Button
                            variant='outlined'
                            component='label'
                            size='small'
                            fullWidth
                            sx={{
                              borderStyle: 'dashed',
                              py: 1.5,
                              justifyContent: 'flex-start',
                            }}>
                            <UploadIcon sx={{ mr: 1 }} />
                            Upload ID Photos
                            <input
                              type='file'
                              hidden
                              multiple
                              accept='image/*'
                              onChange={(e) => {
                                const files = Array.from(e.target.files || []);
                                if (!files.length) return;

                                setGuests((prev) => {
                                  const g = [...prev];
                                  const existing = g[index].idPhotos || [];

                                  // 🔥 prevent double image
                                  const uniqueFiles = files.filter(
                                    (file) =>
                                      !existing.some(
                                        (f) =>
                                          f.name === file.name &&
                                          f.size === file.size,
                                      ),
                                  );

                                  g[index].idPhotos = [
                                    ...existing,
                                    ...uniqueFiles,
                                  ];
                                  return g;
                                });

                                e.target.value = ''; // same image dobara select ho sake
                              }}
                            />
                          </Button>
                        </Grid>

                        {/* TITLE + NAME */}
                        <Grid container spacing={2} mb={2}>
                          <Grid item xs={12} sm={2}>
                            <TextField
                              select
                              label='Title'
                              size='small'
                              fullWidth
                              value={guest.title}
                              onChange={(e) => {
                                const g = [...guests];
                                g[index].title = e.target.value;
                                setGuests(g);
                              }}>
                              <MenuItem value='Mr'>Mr</MenuItem>
                              <MenuItem value='Mrs'>Mrs</MenuItem>
                              <MenuItem value='Ms'>Ms</MenuItem>
                            </TextField>
                          </Grid>

                          <Grid item xs={12} sm={4}>
                            <TextField
                              label='First Name *'
                              size='small'
                              fullWidth
                              value={guest.firstName}
                              onChange={(e) => {
                                const g = [...guests];
                                g[index].firstName = e.target.value;
                                setGuests(g);
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <TextField
                              label='Last Name'
                              size='small'
                              fullWidth
                              value={guest.lastName}
                              onChange={(e) => {
                                const g = [...guests];
                                g[index].lastName = e.target.value;
                                setGuests(g);
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <TextField
                              label='Mobile *'
                              size='small'
                              fullWidth
                              value={guest.mobileNumber}
                              onChange={(e) => {
                                const mobile = e.target.value;

                                const g = [...guests];
                                g[index].mobileNumber = mobile;
                                setGuests(g);

                                // 🔥 Call API when 10 digit entered
                                if (mobile.length === 10) {
                                  fetchGuestByMobile(mobile);
                                }
                              }}
                            />
                          </Grid>

                          {/* #9: previous-visits badge for the primary guest —
                              shows past bookings (with ID image) on click.
                              Book Again lives in the Guest Report now; here the
                              badge is history-only. */}
                          {index === 0 && (
                            <Grid item xs={12}>
                              <GuestHistoryBadge mobile={guest.mobileNumber} />
                            </Grid>
                          )}

                          <Grid item xs={12} sm={3}>
                            <TextField
                              type='date'
                              label='DOB *'
                              size='small'
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              value={guest.dob || ''}
                              onChange={(e) => {
                                const dob = e.target.value;

                                const g = [...guests];
                                g[index].dob = dob;
                                g[index].age = calculateAge(dob); // 👈 AUTO AGE

                                setGuests(g);
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <TextField
                              label='Age'
                              size='small'
                              fullWidth
                              value={guest.age || ''}
                              disabled
                            />
                          </Grid>
                        </Grid>

                        {/* PRIMARY GUEST EXTRA DETAILS */}
                        {isPrimary && (
                          <>
                            <TextField
                              label='Email '
                              size='small'
                              fullWidth
                              sx={{ mb: 2 }}
                              value={guest.email}
                              onChange={(e) => {
                                const g = [...guests];
                                g[index].email = e.target.value;
                                setGuests(g);
                              }}
                            />

                            <TextField
                              label='Address'
                              size='small'
                              fullWidth
                              multiline
                              rows={2}
                              sx={{ mb: 2 }}
                              value={guest.address}
                              onChange={(e) => {
                                const g = [...guests];
                                g[index].address = e.target.value;
                                setGuests(g);
                              }}
                            />
                            <Grid container spacing={2} mb={2}>
                              <Grid item xs={12}>
                                <TextField
                                  select
                                  label='Country'
                                  size='small'
                                  fullWidth
                                  value={guest.country}
                                  onChange={(e) => {
                                    const g = [...guests];
                                    g[index].country = e.target.value;
                                    g[index].state = '';
                                    g[index].city = '';
                                    setGuests(g);
                                  }}>
                                  {allCountries.map((c) => (
                                    <MenuItem key={c.isoCode} value={c.name}>
                                      {c.name}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </Grid>
                            </Grid>

                            <Grid container spacing={2} mb={2}>
                              <Grid container spacing={2} mb={2}>
                                <Grid item xs={12}>
                                  <Autocomplete
                                    options={State.getStatesOfCountry(
                                      allCountries.find(
                                        (c) => c.name === guest.country,
                                      )?.isoCode || '',
                                    )}
                                    getOptionLabel={(option) => option.name}
                                    value={
                                      State.getStatesOfCountry(
                                        allCountries.find(
                                          (c) => c.name === guest.country,
                                        )?.isoCode || '',
                                      ).find((s) => s.name === guest.state) ||
                                      null
                                    }
                                    onChange={(e, value) => {
                                      const g = [...guests];
                                      g[index].state = value ? value.name : '';
                                      g[index].city = '';
                                      setGuests(g);

                                      const countryCode = allCountries.find(
                                        (c) => c.name === g[index].country,
                                      )?.isoCode;

                                      if (value) {
                                        const cityList = City.getCitiesOfState(
                                          countryCode,
                                          value.isoCode,
                                        );

                                        // 🔥 IMPORTANT (multi guest safe)
                                        setCities((prev) => ({
                                          ...prev,
                                          [index]: cityList,
                                        }));
                                      } else {
                                        setCities((prev) => ({
                                          ...prev,
                                          [index]: [],
                                        }));
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label='State'
                                        size='small'
                                        fullWidth
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>

                              <Grid container spacing={2} mb={2}>
                                <Grid item xs={12}>
                                  {guests.map((guest, index) => {
                                    const cityOptions = cities[index] || [];

                                    return (
                                      <Autocomplete
                                        key={index}
                                        options={cityOptions}
                                        getOptionLabel={(option) =>
                                          option.name || ''
                                        }
                                        value={
                                          cityOptions.find(
                                            (c) => c.name === guest.city,
                                          ) || null
                                        }
                                        onChange={(e, val) => {
                                          const g = [...guests];
                                          g[index].city = val?.name || '';
                                          setGuests(g);
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label='City'
                                            size='small'
                                            fullWidth
                                          />
                                        )}
                                      />
                                    );
                                  })}
                                </Grid>
                              </Grid>
                            </Grid>

                            {guest.nationality === 'Indian' ? (
                              <></>
                            ) : (
                              <>
                                <br></br>
                                <Grid item xs={6}>
                                  <TextField
                                    label='Passport Number'
                                    size='small'
                                    fullWidth
                                    value={guest.passportNumber}
                                    onChange={(e) => {
                                      const g = [...guests];
                                      g[index].passportNumber = e.target.value;
                                      setGuests(g);
                                    }}
                                  />
                                </Grid>
                                <br></br>
                                <Grid item xs={6}>
                                  <TextField
                                    label='Visa Number'
                                    size='small'
                                    fullWidth
                                    value={guest.visaNumber}
                                    onChange={(e) => {
                                      const g = [...guests];
                                      g[index].visaNumber = e.target.value;
                                      setGuests(g);
                                    }}
                                  />
                                </Grid>
                              </>
                            )}
                          </>
                        )}
                        <br></br>
                        {/* ID PHOTO */}

                        {guest.idPhotos?.length > 0 && (
                          <Box
                            sx={{
                              mt: 2,
                              display: 'flex',
                              gap: 2,
                              flexWrap: 'wrap',
                            }}>
                            {guest.idPhotos.map((file, i) => (
                              <Box
                                key={i}
                                sx={{
                                  width: 90,
                                  height: 90,
                                  borderRadius: 2,
                                  overflow: 'hidden',
                                  border: '1px solid #ddd',
                                  position: 'relative',
                                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                }}>
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt='ID Preview'
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                />

                                {/* ❌ Remove Image */}
                                <IconButton
                                  size='small'
                                  sx={{
                                    position: 'absolute',
                                    top: 2,
                                    right: 2,
                                    bgcolor: 'rgba(0,0,0,0.6)',
                                    color: 'white',
                                    '&:hover': { bgcolor: 'red' },
                                  }}
                                  onClick={() => {
                                    setGuests((prev) => {
                                      const g = [...prev];
                                      g[index].idPhotos.splice(i, 1);
                                      return g;
                                    });
                                  }}>
                                  ✕
                                </IconButton>
                              </Box>
                            ))}
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              </Card>

              <Card
                sx={{
                  mb: 4,
                  p: 3,
                  borderRadius: 3,
                  background: 'linear-gradient(145deg, #ffffff, #f3f7ff)',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.05)',
                }}>
                <Typography
                  variant='h6'
                  fontWeight='bold'
                  sx={{ mb: 2, color: '#1565c0' }}>
                  🧑‍💼 Booking Source
                </Typography>

                {/* SOURCE DROPDOWN */}
                <TextField
                  select
                  label='Booking Type'
                  fullWidth
                  size='small'
                  value={bookingSource}
                  onChange={(e) => {
                    setBookingSource(e.target.value);
                    if (e.target.value === 'WalkIn') {
                      setAgentDetails({
                        agentId: '',
                        referenceNo: '',
                        remark: '',
                      });
                    }
                  }}
                  sx={{ mb: 2 }}>
                  <MenuItem value='WalkIn'>Walk In</MenuItem>
                  <MenuItem value='Agent'>Through Agent</MenuItem>
                </TextField>

                {/* 🔥 AGENT DETAILS (ONLY IF AGENT SELECTED) */}
                <Collapse in={bookingSource === 'Agent'}>
                  <Grid container spacing={2}>
                    <TextField
                      select
                      label='Agent Name *'
                      fullWidth
                      size='small'
                      value={agentDetails.agentId}
                      onChange={(e) =>
                        setAgentDetails({
                          ...agentDetails,
                          agentId: e.target.value,
                        })
                      }>
                      {agents.map((a) => (
                        <MenuItem key={a.id} value={a.id}>
                          {a.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label='Reference No *'
                        fullWidth
                        size='small'
                        value={agentDetails.referenceNo}
                        onChange={(e) =>
                          setAgentDetails({
                            ...agentDetails,
                            referenceNo: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label='Remark *'
                        fullWidth
                        size='small'
                        value={agentDetails.remark}
                        onChange={(e) =>
                          setAgentDetails({
                            ...agentDetails,
                            remark: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                </Collapse>
              </Card>

              {/* ---------- COMPANY DETAILS ---------- */}
              <Collapse in={billingType === 'Company'}>
                <Card
                  variant='outlined'
                  sx={{
                    mb: 4,
                    p: 3,
                    borderRadius: 3,
                    background: 'linear-gradient(145deg, #fffbea, #fff7e0)',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.05)',
                  }}>
                  <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='space-between'
                    mb={2}>
                    <Typography
                      variant='h6'
                      sx={{
                        fontWeight: 'bold',
                        color: '#c67c00',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}>
                      🏢 Company Details
                    </Typography>
                    <IconButton
                      onClick={() => setCompanyFormOpen(!companyFormOpen)}>
                      {companyFormOpen ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                  </Box>

                  <Collapse in={companyFormOpen}>
                    {/* Row — Company Name | GST No */}
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 2,
                        mb: 2,
                        flexWrap: 'nowrap',
                        '@media (max-width: 900px)': { flexWrap: 'wrap' },
                      }}>
                      <TextField
                        label='Company Name *'
                        fullWidth
                        size='small'
                        value={companyForm.companyName}
                        error={!!companyFormErrors.companyName}
                        helperText={companyFormErrors.companyName}
                        onChange={(e) =>
                          setCompanyForm({
                            ...companyForm,
                            companyName: e.target.value,
                          })
                        }
                        sx={{ flex: 1 }}
                      />

                      <TextField
                        label='GST No *'
                        fullWidth
                        size='small'
                        value={companyForm.gstNo}
                        error={!!companyFormErrors.gstNo}
                        helperText={companyFormErrors.gstNo}
                        onChange={(e) =>
                          setCompanyForm({
                            ...companyForm,
                            gstNo: e.target.value,
                          })
                        }
                        sx={{ flex: 1 }}
                      />
                    </Box>

                    {/* Row — Address (Full Width) */}
                    <Box sx={{ mb: 2 }}>
                      <TextField
                        label='Address *'
                        fullWidth
                        size='small'
                        multiline
                        rows={2}
                        value={companyForm.address}
                        error={!!companyFormErrors.address}
                        helperText={companyFormErrors.address}
                        onChange={(e) =>
                          setCompanyForm({
                            ...companyForm,
                            address: e.target.value,
                          })
                        }
                      />
                    </Box>

                    {/* Row — City | Mobile */}
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 2,
                        mb: 2,
                        flexWrap: 'nowrap',
                        '@media (max-width: 900px)': { flexWrap: 'wrap' },
                      }}>
                      <TextField
                        label='City *'
                        fullWidth
                        size='small'
                        value={companyForm.city}
                        error={!!companyFormErrors.city}
                        helperText={companyFormErrors.city}
                        onChange={(e) =>
                          setCompanyForm({
                            ...companyForm,
                            city: e.target.value,
                          })
                        }
                        sx={{ flex: 1 }}
                      />

                      <TextField
                        label='Mobile Number *'
                        fullWidth
                        size='small'
                        value={companyForm.mobileNumber}
                        error={!!companyFormErrors.mobileNumber}
                        helperText={companyFormErrors.mobileNumber}
                        onChange={(e) =>
                          setCompanyForm({
                            ...companyForm,
                            mobileNumber: e.target.value,
                          })
                        }
                        sx={{ flex: 1 }}
                      />
                    </Box>

                    {/* Row — State (Full Width) */}
                    <Box sx={{ mb: 2 }}>
                      <TextField
                        select
                        label='State *'
                        fullWidth
                        size='small'
                        value={companyForm.state}
                        error={!!companyFormErrors.state}
                        helperText={companyFormErrors.state}
                        onChange={(e) =>
                          setCompanyForm({
                            ...companyForm,
                            state: e.target.value,
                          })
                        }>
                        {State.getStatesOfCountry('IN').map((s) => (
                          <MenuItem key={s.isoCode} value={s.name}>
                            {s.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>

                    {/* Row — Email (Full Width) */}
                    <Box>
                      <TextField
                        label='Email *'
                        type='email'
                        fullWidth
                        size='small'
                        value={companyForm.email}
                        error={!!companyFormErrors.email}
                        helperText={companyFormErrors.email}
                        onChange={(e) =>
                          setCompanyForm({
                            ...companyForm,
                            email: e.target.value,
                          })
                        }
                      />
                    </Box>
                  </Collapse>
                </Card>
              </Collapse>

              {/* Agent / OTA bookings: no add-ons, discount or guest-side
                  payment — just guest details + booking. */}
              {bookingSource !== 'Agent' && (
              <>
              {/* ---------- ADD-ONS ---------- */}
              <Typography
                variant='h6'
                sx={{
                  mb: 2,
                  color: '#ff9800',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}>
                ➕ Add-ons
              </Typography>

              <Card
                sx={{
                  mb: 4,
                  p: 3,
                  borderRadius: 3,
                  background: 'linear-gradient(145deg, #ffffff, #fafbff)',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.05)',
                }}>
                <Box sx={{ mb: 2 }}>
                  <TextField
                    select
                    label='Select Addons'
                    fullWidth
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) =>
                        selected
                          .map((id) => {
                            const item = allAddons.find((a) => a.id === id);
                            return item ? item.name : '';
                          })
                          .join(', '),
                    }}
                    value={selectedAddonIds}
                    onChange={(e) => handleAddonSelection(e.target.value)}
                    sx={{ mb: 2 }}>
                    {allAddons.map((addon) => (
                      <MenuItem key={addon.id} value={addon.id}>
                        <Box
                          display='flex'
                          alignItems='center'
                          justifyContent='space-between'
                          width='100%'>
                          <Typography>{addon.name}</Typography>
                          <Typography color='text.secondary' fontSize='0.85rem'>
                            {Companycurrency}
                            {addon.price}
                          </Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>

                  {selectedAddons.length > 0 && (
                    <Paper
                      variant='outlined'
                      sx={{
                        mt: 2,
                        p: 2,
                        borderRadius: 2,
                        background: '#fff8e1',
                        border: '1px solid #ffe082',
                      }}>
                      <Typography
                        variant='subtitle1'
                        fontWeight='bold'
                        gutterBottom>
                        Selected Add-ons
                      </Typography>
                      {selectedAddons.map((a) => (
                        <Box
                          key={a.id}
                          display='flex'
                          alignItems='center'
                          justifyContent='space-between'
                          sx={{ mb: 1 }}>
                          <Typography sx={{ width: '40%' }}>
                            {a.name} ({Companycurrency}
                            {a.price})
                          </Typography>

                          <TextField
                            type='number'
                            size='small'
                            label='Qty'
                            sx={{ width: 80 }}
                            value={a.qty}
                            onChange={(e) =>
                              updateAddonQty(a.id, e.target.value)
                            }
                            inputProps={{ min: 1 }}
                          />

                          <Typography fontWeight='bold'>
                            {Companycurrency}
                            {(a.price * a.qty).toFixed(2)}
                          </Typography>
                        </Box>
                      ))}

                      <Divider sx={{ my: 1 }} />
                      <Box display='flex' justifyContent='space-between'>
                        <Typography fontWeight='bold'>
                          Total Addon Price
                        </Typography>
                        <Typography fontWeight='bold'>
                          {Companycurrency}
                          {addonTotal.toFixed(2)}
                        </Typography>
                      </Box>
                    </Paper>
                  )}
                </Box>
              </Card>

              {/* ---------- DISCOUNT & PAYMENT ---------- */}
              <Typography
                variant='h6'
                sx={{
                  mb: 2,
                  color: '#4caf50',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}>
                💳 Discount & Payment
              </Typography>

              <Card
                sx={{
                  p: 3,
                  borderRadius: 3,
                  background: 'linear-gradient(145deg, #ffffff, #f9fbff)',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.05)',
                }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      label='Discount Type'
                      fullWidth
                      value={discount.type}
                      onChange={(e) =>
                        setDiscount({ ...discount, type: e.target.value })
                      }>
                      <MenuItem value='%'>%</MenuItem>
                      <MenuItem value='Rs'>{Companycurrency}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Discount Value'
                      type='number'
                      fullWidth
                      value={discount.value}
                      onChange={(e) =>
                        setDiscount({ ...discount, value: e.target.value })
                      }
                    />
                  </Grid>
                </Grid>
                <br></br>
                <Grid container spacing={2}>
                  {/* ---------- COUPON ---------- */}
                  <Grid item xs={12}>
                    <Typography
                      variant='h6'
                      sx={{ mb: 1.5, fontWeight: 'bold' }}>
                      🎟 Apply Voucher
                    </Typography>

                    <TextField
                      select
                      label='Select Coupon'
                      fullWidth
                      value={selectedCoupon ? selectedCoupon.id : ''}
                      onChange={(e) => {
                        const value = e.target.value;

                        // 🔴 No Coupon selected
                        if (value === '') {
                          setSelectedCoupon(null);
                          return;
                        }

                        // ✅ Coupon selected
                        const coupon = coupons.find((c) => c.id === value);
                        setSelectedCoupon(coupon || null);
                      }}>
                      <MenuItem value=''>No Coupon</MenuItem>

                      {coupons.map((c) => (
                        <MenuItem key={c.id} value={c.id}>
                          {c.coupencode} —{' '}
                          {c.type === 'PERCENT'
                            ? `${c.amount}% OFF`
                            : `${Companycurrency}${c.amount} OFF`}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>

                {/* Payment Mode */}
                <Box mt={3}>
                  <Typography
                    variant='subtitle1'
                    fontWeight='bold'
                    gutterBottom>
                    Payment Modes *
                  </Typography>

                  {payments.map((p, i) => (
                    <Paper
                      key={i}
                      sx={{
                        p: 2,
                        mb: 2,
                        borderRadius: 2,
                        background: '#f9f9f9',
                        border: '1px solid #e0e0e0',
                      }}>
                      <Grid container spacing={2}>
                        {/* Payment Mode Selector */}
                        <Grid item xs={12} sm={3}>
                          <TextField
                            select
                            label='Mode'
                            fullWidth
                            size='small'
                            value={p.mode}
                            onChange={(e) =>
                              handlePaymentChange(i, 'mode', e.target.value)
                            }>
                            <MenuItem value='Cash'>Cash</MenuItem>
                            <MenuItem value='UPI'>UPI</MenuItem>
                            <MenuItem value='Online'>Online</MenuItem>
                            <MenuItem value='Card'>Card</MenuItem>
                          </TextField>
                        </Grid>

                        {/* Amount Input */}
                        <Grid item xs={12} sm={3}>
                          <TextField
                            label={`Amount (${Companycurrency})`}
                            type='number'
                            fullWidth
                            size='small'
                            value={p.amount}
                            onChange={(e) =>
                              handlePaymentChange(i, 'amount', e.target.value)
                            }
                          />
                        </Grid>

                        {/* Conditional Fields */}
                        {['UPI', 'Online'].includes(p.mode) && (
                          <Grid item xs={12} sm={4}>
                            <TextField
                              label='Reference No'
                              fullWidth
                              size='small'
                              value={p.referenceNo}
                              onChange={(e) =>
                                handlePaymentChange(
                                  i,
                                  'referenceNo',
                                  e.target.value,
                                )
                              }
                            />
                          </Grid>
                        )}

                        {p.mode === 'Card' && (
                          <>
                            <Grid item xs={12} sm={2.5}>
                              <TextField
                                select
                                label='Card Type'
                                fullWidth
                                size='small'
                                value={p.cardType}
                                onChange={(e) =>
                                  handlePaymentChange(
                                    i,
                                    'cardType',
                                    e.target.value,
                                  )
                                }>
                                <MenuItem value='Credit'>Credit</MenuItem>
                                <MenuItem value='Debit'>Debit</MenuItem>
                              </TextField>
                            </Grid>

                            <Grid item xs={12} sm={3.5}>
                              <TextField
                                label='Card Number'
                                fullWidth
                                size='small'
                                inputProps={{ maxLength: 16 }}
                                value={p.cardNumber}
                                onChange={(e) =>
                                  handlePaymentChange(
                                    i,
                                    'cardNumber',
                                    e.target.value,
                                  )
                                }
                              />
                            </Grid>
                          </>
                        )}

                        {/* Remove Button */}
                        <Grid item xs={12} sm='auto'>
                          <IconButton
                            color='error'
                            onClick={() => removePaymentRow(i)}>
                            <Remove />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Paper>
                  ))}
                  <Grid item xs={12} sm={3}>
                    <TextField
                      label={`Pending Amount (${Companycurrency})`}
                      fullWidth
                      size='small'
                      value={finalBalanceAfterCoupon.toFixed(2)}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <br></br>
                  {/* Add New Payment Button */}
                  <Button
                    startIcon={<Add />}
                    variant='outlined'
                    color='primary'
                    sx={{ mb: 2 }}
                    onClick={addPaymentRow}>
                    Add Another Payment
                  </Button>

                  {/* Total Payment Summary */}
                  <Divider sx={{ my: 2 }} />
                  <Typography fontWeight='bold' sx={{ color: '#2e7d32' }}>
                    Total Paid: {Companycurrency}
                    {payments
                      .reduce((a, b) => a + Number(b.amount || 0), 0)
                      .toFixed(2)}
                  </Typography>
                </Box>

                {/* 🆕 Customer Final Price field — disabled for OTA booking
                    because the price comes from the OTA Booking Price */}
                <Grid item xs={12}>
                  <TextField
                    label={`Customer Final Price Wants (${Companycurrency}) (Incl. GST)`}
                    type='number'
                    fullWidth
                    value={desiredFinalPrice}
                    disabled={isOtaBooking}
                    onChange={(e) => {
                      setDesiredFinalPrice(e.target.value);
                      setIsCustomerFinalWithGST(true); // 🔥 IMPORTANT
                    }}
                    helperText={
                      isOtaBooking
                        ? 'Locked: using Agent/OTA Booking Price (incl. GST)'
                        : 'Amount entered is FINAL price including GST'
                    }
                  />
                </Grid>
                {/* ---------- BOOKING REMARK ---------- */}
                <Typography
                  variant='h6'
                  sx={{
                    mt: 3,
                    mb: 1,
                    color: '#6a1b9a',
                    fontWeight: 'bold',
                  }}>
                  📝 Booking Remark
                </Typography>

                <TextField
                  label='Remark / Special Instruction'
                  fullWidth
                  multiline
                  rows={3}
                  value={bookingRemark}
                  onChange={(e) => setBookingRemark(e.target.value)}
                  placeholder='Any special instruction, late check-in, complimentary request, etc.'
                />
              </Card>
              </>
              )}
            </Box>
            <Box mt={4} textAlign='center'>
              <Button
                variant='contained'
                color='success'
                size='large'
                onClick={handleBooking}
                disabled={loading}
                startIcon={
                  loading ? (
                    <CircularProgress size={20} color='inherit' />
                  ) : null
                }>
                {loading
                  ? 'Booking...'
                  : `Confirm & Book (Balance: ${finalBalanceAfterCoupon.toFixed(2)})`}
              </Button>
            </Box>
          </Paper>
        )}

        {step === 4 && bookingData && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}>
            <Container
              maxWidth='md'
              sx={{
                py: 6,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Paper
                sx={{
                  width: '100%',
                  borderRadius: 5,
                  overflow: 'hidden',
                  background:
                    'linear-gradient(135deg, #ffffff 0%, #f6f9ff 100%)',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
                }}>
                {/* HEADER BAR */}
                <Box
                  sx={{
                    background:
                      'linear-gradient(135deg, #004e92 0%, #000428 100%)',
                    color: 'white',
                    py: 3,
                    px: { xs: 3, sm: 5 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  <Box>
                    <Typography variant='subtitle2' sx={{ opacity: 0.8 }}>
                      Official Booking Voucher
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      background: 'rgba(255,255,255,0.15)',
                      px: 2.5,
                      py: 0.5,
                      borderRadius: 2,
                      fontWeight: 600,
                      fontSize: '0.95rem',
                      border: '1px solid rgba(255,255,255,0.2)',
                    }}></Box>
                </Box>

                {/* MAIN CONTENT */}
                <Box sx={{ p: { xs: 3, sm: 5 }, position: 'relative' }}>
                  {/* HEADER TEXT */}
                  <Typography
                    variant='h4'
                    fontWeight='700'
                    textAlign='center'
                    sx={{
                      background: 'linear-gradient(90deg, #004b8d, #007bff)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      mb: 0.5,
                    }}>
                    Booking Confirmed 🎉
                  </Typography>
                  <Typography
                    textAlign='center'
                    color='text.secondary'
                    sx={{ mb: 4 }}>
                    Thank you for booking with{' '}
                    <b>
                      {
                        hotels.find((h) => h.id == bookingData.HotelId)
                          ?.hotelName
                      }
                    </b>
                    ! Your stay has been successfully confirmed.
                  </Typography>

                  {/* 🆕 OTA tag on voucher */}
                  {bookingData.AgentBookingType === 'OTA' &&
                    bookingData.AgentBooking && (
                      <Box
                        sx={{
                          mb: 3,
                          p: 2,
                          borderRadius: 3,
                          background:
                            'linear-gradient(145deg,#fff7ed,#ffedd5)',
                          border: '1px solid #fb923c',
                        }}>
                        <Typography
                          variant='h6'
                          sx={{ fontWeight: 700, color: '#9a3412', mb: 1 }}>
                          🤝 Agent / OTA Booking
                        </Typography>
                        <Typography>
                          <b>Agent:</b>{' '}
                          {bookingData.AgentBooking.AgentName || '-'}
                        </Typography>
                        <Typography>
                          <b>Booking Price (incl. GST):</b> {Companycurrency}
                          {Number(
                            bookingData.AgentBooking.BookingPriceWithGST,
                          ).toFixed(2)}
                        </Typography>
                        <Typography>
                          <b>Property Price:</b> {Companycurrency}
                          {Number(
                            bookingData.AgentBooking.PropertyPrice,
                          ).toFixed(2)}
                        </Typography>
                        <Typography sx={{ color: '#16a34a', fontWeight: 700 }}>
                          <b>Commission:</b> {Companycurrency}
                          {Number(
                            bookingData.AgentBooking.Commission,
                          ).toFixed(2)}
                        </Typography>
                      </Box>
                    )}

                  {/* DETAILS GRID */}
                  <Grid container spacing={3}>
                    {/* HOTEL DETAILS */}
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          background:
                            'linear-gradient(145deg, #ffffff, #f0f5ff)',
                          boxShadow: '0 6px 15px rgba(0,0,0,0.05)',
                          border: '1px solid #e1e9f8',
                        }}>
                        <Typography
                          variant='h6'
                          sx={{ fontWeight: '700', color: '#004b8d', mb: 1.5 }}>
                          🏨 Hotel Details
                        </Typography>
                        <Typography>
                          <b>Hotel:</b>{' '}
                          {
                            hotels.find((h) => h.id == bookingData.HotelId)
                              ?.hotelName
                          }
                        </Typography>
                        <Typography>
                          <b>Room Type:</b> {selectedRoom?.roomType}
                        </Typography>
                        <Typography>
                          <b>Rooms:</b> {selectedRooms.join(', ')}
                        </Typography>
                        <Typography>
                          <b>Check-in:</b> {bookingData.CheckInDate}
                        </Typography>
                        <Typography>
                          <b>Check-out:</b> {bookingData.CheckOutDate}
                        </Typography>
                        <Typography>
                          <b>Nights:</b> {bookingData.Nights}
                        </Typography>
                      </Box>
                    </Grid>

                    {/* GUEST DETAILS */}
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          background:
                            'linear-gradient(145deg, #ffffff, #fff5fa)',
                          boxShadow: '0 6px 15px rgba(0,0,0,0.05)',
                          border: '1px solid #f2e1f8',
                        }}>
                        <Typography
                          variant='h6'
                          sx={{ fontWeight: '700', color: '#8e24aa', mb: 1.5 }}>
                          👤 Guest Details
                        </Typography>
                        <Typography>
                          <b>Name:</b> {bookingData.GuestDetails?.Title}{' '}
                          {bookingData.GuestDetails?.FirstName}{' '}
                          {bookingData.GuestDetails?.LastName}
                        </Typography>
                        <Typography>
                          <b>Email:</b> {bookingData.GuestDetails?.Email}
                        </Typography>
                        <Typography>
                          <b>Mobile:</b>{' '}
                          {bookingData.GuestDetails?.MobileNumber}
                        </Typography>
                        <Typography>
                          <b>City:</b> {bookingData.GuestDetails?.City}
                        </Typography>
                        <Typography>
                          <b>State:</b> {bookingData.GuestDetails?.State}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* PAYMENT CARD */}
                  <Box
                    sx={{
                      mt: 4,
                      p: 3,
                      borderRadius: 3,
                      background: 'linear-gradient(145deg, #ffffff, #f7fff9)',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.07)',
                      border: '1px solid #d2eadd',
                    }}>
                    <Typography
                      variant='h6'
                      sx={{
                        mb: 2,
                        fontWeight: 700,
                        color: '#2e7d32',
                      }}>
                      💳 Payment Summary
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <b>Package:</b> {selectedPkg?.packageName}
                        </Typography>
                        <Typography>
                          <b>Rate / Night:</b>
                          {Companycurrency}
                          {selectedPrice?.price.toFixed(2)}
                        </Typography>
                        {isGstApplicable() && (
                          <Typography>
                            <b>GST:</b> {Companycurrency}
                            {totalGST?.toFixed(2)}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <b>Total:</b>
                          {Companycurrency}
                          {finalAfterCoupon.toFixed(2)}
                        </Typography>
                        <Typography>
                          <b>Paid:</b>
                          {Companycurrency}
                          {Number(totalPaid).toFixed(2)}
                        </Typography>
                        <Typography>
                          <b>Balance:</b>
                          {Companycurrency}
                          {(finalAfterCoupon - totalPaid).toFixed(2)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  {/* FOOTER INFO */}
                  <Box
                    sx={{
                      mt: 4,
                      p: 2.5,
                      borderRadius: 3,
                      background: 'linear-gradient(145deg, #f4f8ff, #ffffff)',
                      border: '1px dashed #c5d4eb',
                      textAlign: 'center',
                    }}>
                    <Typography variant='body2' sx={{ mb: 0.5 }}>
                      <b>Booked On:</b> {bookingData.bookedOn}
                    </Typography>
                    <Typography variant='body2'>
                      <b>Status:</b>{' '}
                      <span style={{ color: '#2e7d32', fontWeight: 600 }}>
                        Confirmed ✅
                      </span>
                    </Typography>
                  </Box>

                  {/* ACTION BUTTONS */}
                  <Box
                    mt={3}
                    textAlign='center'
                    display='flex'
                    gap={2}
                    justifyContent='center'
                    flexWrap='wrap'>
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={() => {
                        window.location.reload();
                      }}>
                      Back to Dashboard
                    </Button>

                    <Button
                      variant='outlined'
                      color='secondary'
                      onClick={() => {
                        window.location.href = '/admin/BookingReport';
                      }}>
                      Go to Bookings
                    </Button>

                    <Button
                      variant='outlined'
                      onClick={() => openBookingFormPrint(true)}>
                      Print Filled Form
                    </Button>

                    <Button
                      variant='outlined'
                      onClick={() => openBookingFormPrint(false)}>
                      Print Blank Form
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Container>
          </motion.div>
        )}
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 999,
            backdropFilter: 'blur(4px)',
            backgroundColor: 'rgba(0,0,0,0.4)',
          }}
          open={loading}>
          <Box textAlign='center'>
            <CircularProgress color='inherit' size={60} />
            <Typography mt={2} fontWeight='bold'>
              Booking in progress, please wait...
            </Typography>
          </Box>
        </Backdrop>
      </Container>
    </>
  );
}
